export const partsCatalog = {


  
//actual 
  Engine: {
  "Cylinder Head": [
    {
  id: 1,
  name: "COVER, CYLINDER HEAD",
  oem: "6BH-11191-20-00",
  price: 314.99,
  stock: true
},
{
  id: 2,
  name: "BOLT, FLANGE",
  oem: "90105-06028-00",
  price: 3.55,
  stock: true
},
{
  id: 3,
  name: "GASKET, HEAD COVER",
  oem: "6BH-11193-00-00",
  price: 48.49,
  stock: true
},
{
  id: 4,
  name: "COVER ASSY",
  oem: "6BH-E110M-00-00",
  price: 50.99,
  stock: true
},
{
  id: 5,
  name: "GROMMET, ANODE",
  oem: "6S5-E1328-00-00",
  price: 6.99,
  stock: true
},
{
  id: 6,
  name: "BOLT, COVER MOUNTING",
  oem: "6S5-E118E-00-00",
  price: 3.99,
  stock: true
},
{
  id: 7,
  name: "DAMPER, IGNITION COIL",
  oem: "61N-82317-00-00",
  price: 1.10,
  stock: true
},
{
  id: 8,
  name: "COLLAR",
  oem: "90387-06119-00",
  price: 4.80,
  stock: true
},
{
  id: 9,
  name: "BOLT, FLANGE",
  oem: "95824-06025-00",
  price: 10.49,
  stock: true
},
{
  id: 10,
  name: "PLUG, OIL",
  oem: "6S5-15363-00-00",
  price: 15.99,
  stock: true
},
{
  id: 11,
  name: "O-RING",
  oem: "93210-24M79-00",
  price: 8.49,
  stock: true
},


{
  id: 12,
  name: "CYLINDER HEAD COMPLETE",
  oem: "6BH-W009A-03-94",
  price: 5441.49,
  stock: true
},
{
  id: 13,
  name: "CYLINDER HEAD ASSY",
  oem: "6BH-11102-11-00",
  price: 2368.99,
  stock: true
},
{
  id: 14,
  name: "GUIDE, VALVE",
  oem: "6S5-11133-10-00",
  price: 58.49,
  stock: true
},
{
  id: 15,
  name: "PIN, DOWEL",
  oem: "91809-16002-00",
  price: 2.49,
  stock: true
},
{
  id: 16,
  name: "PIN, DOWEL",
  oem: "91809-16002-00",
  price: 2.49,
  stock: true
},
{
  id: 17,
  name: "BOLT, FLANGE",
  oem: "90105-07009-00",
  price: 3.99,
  stock: true
},
{
  id: 18,
  name: "BOLT",
  oem: "6S5-12228-01-00",
  price: 19.49,
  stock: true
},
{
  id: 19,
  name: "WASHER, PLATE",
  oem: "90201-12039-00",
  price: 3.99,
  stock: true
},
{
  id: 20,
  name: "BOLT",
  oem: "97013-06055-00",
  price: 3.50,
  stock: true
},
{
  id: 21,
  name: "WASHER, PLATE",
  oem: "92903-06600-00",
  price: 2.85,
  stock: true
},
{
  id: 22,
  name: "GASKET, CYLINDER HEAD",
  oem: "6BH-11181-00-00",
  price: 155.49,
  stock: true
},
{
  id: 23,
  name: "HANGER, ENGINE",
  oem: "6BH-1111E-00-00",
  price: 23.49,
  stock: true
},
{
  id: 24,
  name: "BOLT, WITH WASHER",
  oem: "90119-06078-00",
  price: 2.49,
  stock: true
},
{
  id: 25,
  name: "HANGER, ENGINE",
  oem: "6BH-11119-00-00",
  price: 23.49,
  stock: true
},
{
  id: 26,
  name: "BOLT, WITH WASHER",
  oem: "97513-10525-00",
  price: 3.49,
  stock: true
},
{
  id: 27,
  name: "THERMOSTAT",
  oem: "6D3-12411-00-00",
  price: 125.49,
  stock: true
},
{
  id: 28,
  name: "COVER, THERMOSTAT",
  oem: "6BH-12413-00-00",
  price: 39.99,
  stock: true
},
{
  id: 29,
  name: "BOLT, FLANGE",
  oem: "90105-06035-00",
  price: 2.49,
  stock: true
},
{
  id: 30,
  name: "HOSE",
  oem: "6S5-12578-00-00",
  price: 62.99,
  stock: true
},
{
  id: 31,
  name: "TUBE (L850)",
  oem: "90447-28008-00",
  price: 18.49,
  stock: true
},
{
  id: 32,
  name: "CLIP",
  oem: "90467-240A0-00",
  price: 7.49,
  stock: true
}
 

           ],

  "Crankcase": [
 
{
  id: 1,
  name: "CRANKCASE ASSY",
  oem: "6CR-15100-11-00",
  price: 6611.30,
  stock: true
},
{
  id: 2,
  name: "PIN, DOWEL",
  oem: "99530-10114-00",
  price: 2.65,
  stock: true
},
{
  id: 3,
  name: "O-RING",
  oem: "93210-11453-00",
  price: 8.49,
  stock: true
},
{
  id: 4,
  name: "CYLINDER BLOCK ASSY",
  oem: "6CR-W009B-11-94",
  price: 7986.49,
  stock: true
},
{
  id: 5,
  name: "BOLT, FLANGE",
  oem: "90105-10071-00",
  price: 14.15,
  stock: true
},
{
  id: 6,
  name: "BOLT, FLANGE",
  oem: "95814-06070-00",
  price: 9.49,
  stock: true
},
{
  id: 7,
  name: "PIN, DOWEL",
  oem: "93606-12019-00",
  price: 4.60,
  stock: true
},
{
  id: 8,
  name: "PIN, DOWEL",
  oem: "93604-10M03-00",
  price: 5.20,
  stock: true
},
{
  id: 9,
  name: "ANODE COVER ASSY",
  oem: "69J-11301-10-00",
  price: 17.99,
  stock: true
},
{
  id: 10,
  name: "ANODE",
  oem: "68V-11325-02-00",
  price: 22.20,
  stock: true
},
{
  id: 11,
  name: "GROMMET, ANODE",
  oem: "67F-11328-00-00",
  price: 3.80,
  stock: true
},
{
  id: 12,
  name: "BOLT, FLANGE",
  oem: "90105-06M07-00",
  price: 2.30,
  stock: true
},
{
  id: 13,
  name: "GASKET",
  oem: "90430-06M03-00",
  price: 3.65,
  stock: true
},
{
  id: 14,
  name: "BOLT",
  oem: "97095-08040-00",
  price: 4.55,
  stock: true
},
{
  id: 15,
  name: "WASHER",
  oem: "92995-08600-00",
  price: 2.70,
  stock: true
},
{
  id: 16,
  name: "HOSE",
  oem: "6S5-11377-00-00",
  price: 40.99,
  stock: true
},
{
  id: 17,
  name: "COVER",
  oem: "6S5-1131M-10-8P",
  price: 144.49,
  stock: true
},
{
  id: 18,
  name: "GASKET",
  oem: "6BH-13557-00-00",
  price: 37.49,
  stock: true
},
{
  id: 19,
  name: "BOLT, FLANGE (SMALL HEAD)",
  oem: "95024-06014-00",
  price: 4.05,
  stock: true
},
{
  id: 20,
  name: "BOLT, FLANGE (SMALL HEAD)",
  oem: "95024-06020-00",
  price: 6.49,
  stock: true
},
{
  id: 21,
  name: "JOINT",
  oem: "6CS-12469-A0-00",
  price: 81.49,
  stock: true
},
{
  id: 22,
  name: "GASKET, WATER INLET",
  oem: "6CS-12517-00-00",
  price: 20.99,
  stock: true
},
{
  id: 23,
  name: "BOLT, FLANGE",
  oem: "95814-06035-00",
  price: 8.49,
  stock: true
},
{
  id: 24,
  name: "PLATE, BAFFLE LOWER",
  oem: "6S5-13337-10-00",
  price: 3.99,
  stock: true
},
{
  id: 25,
  name: "BOLT, HEXAGON SOCKET HEAD",
  oem: "90110-06182-00",
  price: 9.49,
  stock: true
},
{
  id: 26,
  name: "PIN, DOWEL",
  oem: "99530-10114-00",
  price: 2.65,
  stock: true
},
{
  id: 27,
  name: "COVER, JOINT",
  oem: "6BH-1131C-00-00",
  price: 14.49,
  stock: true
},
{
  id: 28,
  name: "GASKET, COVER",
  oem: "6BH-1131B-00-00",
  price: 3.99,
  stock: true
},
{
  id: 29,
  name: "BOLT, FLANGE",
  oem: "95814-08020-00",
  price: 9.49,
  stock: true
},
{
  id: 30,
  name: "BOLT, FLANGE",
  oem: "95814-06016-00",
  price: 1.99,
  stock: true
},
{
  id: 31,
  name: "PLUG, OIL LEVEL",
  oem: "6ET-15362-00-00",
  price: 48.49,
  stock: true
},
{
  id: 32,
  name: "O-RING",
  oem: "93210-06632-00",
  price: 9.49,
  stock: true
},
{
  id: 33,
  name: "PIPE, OIL LEVEL",
  oem: "6CS-8572F-00-00",
  price: 101.49,
  stock: true
},
{
  id: 34,
  name: "PLATE",
  oem: "6BH-1319K-00-00",
  price: 10.49,
  stock: true
},
{
  id: 35,
  name: "SPACER",
  oem: "6CS-85516-00-00",
  price: 23.99,
  stock: true
},
{
  id: 36,
  name: "CLIP",
  oem: "90467-150A1-00",
  price: 4.49,
  stock: true
},
{
  id: 37,
  name: "O-RING",
  oem: "93210-12016-00",
  price: 2.99,
  stock: true
},
{
  id: 38,
  name: "BOLT",
  oem: "90109-06268-00",
  price: 3.49,
  stock: true
},
{
  id: 39,
  name: "BOLT, FLANGE",
  oem: "90105-08021-00",
  price: 9.49,
  stock: true
}
],



"Gaskets": [
  {
    id: 1,
    name: "GASKET KIT FOR ENGINE UNIT",
    oem: "6CR-W0001-01-00",
    price: 371.49,
    stock: true
  },
  {
    id: 2,
    name: "GASKET, HEAD COVER 1",
    oem: "6BH-11193-00-00",
    price: 48.49,
    stock: true
  },
  {
    id: 3,
    name: "GASKET, CYLINDER HEAD 1",
    oem: "6BH-11181-00-00",
    price: 155.49,
    stock: true
  },
  {
    id: 4,
    name: "O-RING",
    oem: "93210-11453-00",
    price: 8.49,
    stock: true
  },
  {
    id: 5,
    name: "GASKET, WATER INLET",
    oem: "6CS-12517-00-00",
    price: 20.99,
    stock: true
  },
  {
    id: 6,
    name: "GASKET",
    oem: "6S5-121E2-00-00",
    price: 3.49,
    stock: true
  },
  {
    id: 7,
    name: "GASKET",
    oem: "90430-10007-00",
    price: 5.49,
    stock: true
  },
  {
    id: 8,
    name: "GASKET",
    oem: "6S5-13563-00-00",
    price: 14.49,
    stock: true
  },
  {
    id: 9,
    name: "O-RING",
    oem: "93210-21631-00",
    price: 8.49,
    stock: true
  },
  {
    id: 10,
    name: "O-RING",
    oem: "93210-18322-00",
    price: 5.60,
    stock: true
  },
  {
    id: 11,
    name: "O-RING",
    oem: "93210-12016-00",
    price: 2.99,
    stock: true
  },
  {
    id: 12,
    name: "O-RING",
    oem: "93210-24M79-00",
    price: 8.49,
    stock: true
  },
  {
    id: 13,
    name: "GASKET, MUFFLER DAMPER 1",
    oem: "6S5-14739-00-00",
    price: 29.99,
    stock: true
  },
  {
    id: 14,
    name: "GASKET, MUFFLER DAMPER 2",
    oem: "6BH-14749-00-00",
    price: 23.99,
    stock: true
  },
  {
    id: 15,
    name: "OIL SEAL",
    oem: "6S5-81167-10-00",
    price: 73.99,
    stock: true
  },
  {
    id: 16,
    name: "O-RING",
    oem: "6S5-81168-00-00",
    price: 42.99,
    stock: true
  },
  {
    id: 17,
    name: "O-RING",
    oem: "93210-32172-00",
    price: 8.49,
    stock: true
  },
  {
    id: 18,
    name: "GASKET",
    oem: "6BH-13557-00-00",
    price: 37.49,
    stock: true
  },
  {
    id: 19,
    name: "GASKET, EXHAUST PIPE",
    oem: "6BH-14613-00-00",
    price: 52.99,
    stock: true
  },
  {
    id: 20,
    name: "GASKET, COVER",
    oem: "6BH-1131B-00-00",
    price: 3.99,
    stock: true
  },
  {
    id: 21,
    name: "GASKET KIT FOR JET UNIT",
    oem: "6EW-W0001-20-00",
    price: 193.99,
    stock: true
  },
  {
    id: 22,
    name: "O-RING",
    oem: "93210-22MF1-00",
    price: 8.49,
    stock: true
  },
  {
    id: 23,
    name: "OIL SEAL",
    oem: "93102-29008-00",
    price: 29.99,
    stock: true
  },
  {
    id: 24,
    name: "OIL SEAL",
    oem: "93102-29009-00",
    price: 54.99,
    stock: true
  },
  {
    id: 25,
    name: "O-RING",
    oem: "66V-42414-00-00",
    price: 6.99,
    stock: true
  },
  {
    id: 26,
    name: "OIL SEAL",
    oem: "93102-31009-00",
    price: 80.49,
    stock: true
  },
  {
    id: 27,
    name: "OIL SEAL",
    oem: "93101-31001-00",
    price: 32.99,
    stock: true
  },
  {
    id: 28,
    name: "O-RING",
    oem: "93210-54010-00",
    price: 2.99,
    stock: true
  },
  {
    id: 29,
    name: "O-RING",
    oem: "93210-30611-00",
    price: 14.49,
    stock: true
  }
],


"Motor Mounts": [
  {
    id: 1,
    name: "MOUNT RUBBER",
    oem: "67X-44517-10-00",
    price: 102.49,
    stock: true
  },
  {
    id: 2,
    name: "STOPPER, UPPER MOUNT",
    oem: "6CN-G4532-00-00",
    price: 43.99,
    stock: true
  },
  {
    id: 3,
    name: "STOPPER, LOWER MOUNT RUBBER",
    oem: "6CN-G4574-00-00",
    price: 20.99,
    stock: true
  },
  {
    id: 4,
    name: "BRACKET 1",
    oem: "6BH-41661-00-94",
    price: 178.49,
    stock: true
  },
  {
    id: 5,
    name: "BRACKET 2",
    oem: "6BH-41662-00-94",
    price: 180.49,
    stock: true
  },
  {
    id: 6,
    name: "SCREW",
    oem: "90149-10052-00",
    price: 7.49,
    stock: true
  },
  {
    id: 7,
    name: "BOLT, WITH WASHER",
    oem: "90119-08859-00",
    price: 8.99,
    stock: true
  },
  {
    id: 8,
    name: "BOLT, WITH WASHER",
    oem: "90119-08859-00",
    price: 8.99,
    stock: true
  },
  {
    id: 9,
    name: "BOLT, WITH WASHER",
    oem: "90119-08823-00",
    price: 8.99,
    stock: true
  },
  {
    id: 10,
    name: "BOLT, WITH WASHER",
    oem: "90119-08823-00",
    price: 8.99,
    stock: true
  },

  // SHIMS (all variants kept)
  {
    id: 11,
    name: "SHIM (T=0.1)",
    oem: "EU0-U7354-00-01",
    price: 4.99,
    stock: true
  },
  {
    id: 12,
    name: "SHIM (T=0.3)",
    oem: "EU0-U7354-00-03",
    price: 5.99,
    stock: true
  },
  {
    id: 13,
    name: "SHIM (T=0.5)",
    oem: "EU0-U7354-00-05",
    price: 4.99,
    stock: true
  },
  {
    id: 14,
    name: "SHIM (T=1.0)",
    oem: "EU0-U7354-00-10",
    price: 4.49,
    stock: true
  },
  {
    id: 15,
    name: "SHIM (T=2.0)",
    oem: "EU0-U7354-00-20",
    price: 4.49,
    stock: true
  },

  {
    id: 16,
    name: "PLATE",
    oem: "F2S-U732B-00-00",
    price: 0.00,
    stock: true
  },
  {
    id: 17,
    name: "RIVET, BLIND",
    oem: "90267-489U2-00",
    price: 5.99,
    stock: true
  },
  {
    id: 18,
    name: "PLATE",
    oem: "F2M-U732B-00-00",
    price: 8.99,
    stock: true
  },
  {
    id: 19,
    name: "PLATE",
    oem: "F2M-U732B-00-00",
    price: 8.99,
    stock: true
  },
  {
    id: 20,
    name: "RIVET, BLIND",
    oem: "90267-489U2-00",
    price: 5.99,
    stock: true
  },
  {
    id: 21,
    name: "BOLT",
    oem: "90109-06874-00",
    price: 7.99,
    stock: true
  },
  {
    id: 22,
    name: "BOLT",
    oem: "90109-06875-00",
    price: 7.99,
    stock: true
  }
],

"Valvetrain": [
  {
    id: 1,
    name: "CAMSHAFT 1",
    oem: "6BH-12171-10-00",
    price: 485.49,
    stock: true
  },
  {
    id: 2,
    name: "CAMSHAFT 2",
    oem: "6BH-12181-10-00",
    price: 485.49,
    stock: true
  },
  {
    id: 3,
    name: "SPROCKET, CAM CHAIN",
    oem: "6ET-12176-00-00",
    price: 46.49,
    stock: true
  },
  {
    id: 4,
    name: "BOLT, FLANGE",
    oem: "90105-07006-00",
    price: 9.49,
    stock: true
  },
  {
    id: 5,
    name: "VALVE, INTAKE",
    oem: "6S5-12111-00-00",
    price: 28.49,
    stock: true
  },
  {
    id: 6,
    name: "VALVE, EXHAUST",
    oem: "6S5-12121-00-00",
    price: 54.99,
    stock: true
  },
  {
    id: 7,
    name: "SEAT, VALVE SPRING",
    oem: "6S5-12116-00-00",
    price: 3.49,
    stock: true
  },
  {
    id: 8,
    name: "SPRING, VALVE INNER",
    oem: "6S5-12113-00-00",
    price: 15.49,
    stock: true
  },
  {
    id: 9,
    name: "RETAINER, VALVE SPRING",
    oem: "6S5-12117-00-00",
    price: 6.49,
    stock: true
  },
  {
    id: 10,
    name: "LOCK, VALVE SPRING RETAINER",
    oem: "3LD-12118-00-00",
    price: 2.90,
    stock: true
  },
  {
    id: 11,
    name: "SEAL, VALVE STEM",
    oem: "51Y-12119-00-00",
    price: 7.49,
    stock: true
  },

  // 🔥 ADJUSTING SHIMS (ALL VARIANTS — CRITICAL)
  {
    id: 12,
    name: "PAD, ADJUSTING (1.20)",
    oem: "3LD-12168-00-00",
    price: 17.99,
    stock: true
  },
  {
    id: 13,
    name: "PAD, ADJUSTING (1.25)",
    oem: "3LD-12168-20-00",
    price: 18.99,
    stock: true
  },
  {
    id: 14,
    name: "PAD, ADJUSTING (1.30)",
    oem: "3LD-12168-40-00",
    price: 18.99,
    stock: true
  },
  {
    id: 15,
    name: "PAD, ADJUSTING (1.35)",
    oem: "3LD-12168-60-00",
    price: 12.49,
    stock: true
  },
  {
    id: 16,
    name: "PAD, ADJUSTING (1.40)",
    oem: "3LD-12168-80-00",
    price: 17.49,
    stock: true
  },
  {
    id: 17,
    name: "PAD, ADJUSTING (1.45)",
    oem: "3LD-12168-A0-00",
    price: 11.49,
    stock: true
  },
  {
    id: 18,
    name: "PAD, ADJUSTING (1.50)",
    oem: "3LD-12168-F0-00",
    price: 16.49,
    stock: true
  },
  {
    id: 19,
    name: "PAD, ADJUSTING (1.55)",
    oem: "3LD-12168-H1-00",
    price: 17.49,
    stock: true
  },
  {
    id: 20,
    name: "PAD, ADJUSTING (1.60)",
    oem: "3LD-12168-K1-00",
    price: 12.49,
    stock: true
  },
  {
    id: 21,
    name: "PAD, ADJUSTING (1.65)",
    oem: "3LD-12168-M1-00",
    price: 13.49,
    stock: true
  },
  {
    id: 22,
    name: "PAD, ADJUSTING (1.70)",
    oem: "3LD-12168-R1-00",
    price: 19.99,
    stock: true
  },
  {
    id: 23,
    name: "PAD, ADJUSTING (1.75)",
    oem: "3LD-12168-U1-00",
    price: 18.99,
    stock: true
  },
  {
    id: 24,
    name: "PAD, ADJUSTING (1.80)",
    oem: "3LD-12168-W1-00",
    price: 19.99,
    stock: true
  },
  {
    id: 25,
    name: "PAD, ADJUSTING (1.85)",
    oem: "3LD-12168-Y1-00",
    price: 19.99,
    stock: true
  },
  {
    id: 26,
    name: "PAD, ADJUSTING (1.90)",
    oem: "3LD-12169-11-00",
    price: 19.99,
    stock: true
  },
  {
    id: 27,
    name: "PAD, ADJUSTING (1.95)",
    oem: "3LD-12169-31-00",
    price: 18.99,
    stock: true
  },
  {
    id: 28,
    name: "PAD, ADJUSTING (2.00)",
    oem: "3LD-12169-50-00",
    price: 22.99,
    stock: true
  },
  {
    id: 29,
    name: "PAD, ADJUSTING (2.05)",
    oem: "3LD-12169-70-00",
    price: 18.99,
    stock: true
  },
  {
    id: 30,
    name: "PAD, ADJUSTING (2.10)",
    oem: "3LD-12169-90-00",
    price: 17.49,
    stock: true
  },
  {
    id: 31,
    name: "PAD, ADJUSTING (2.15)",
    oem: "3LD-12169-E0-00",
    price: 17.49,
    stock: true
  },
  {
    id: 32,
    name: "PAD, ADJUSTING (2.20)",
    oem: "3LD-12169-G0-00",
    price: 11.49,
    stock: true
  },
  {
    id: 33,
    name: "PAD, ADJUSTING (2.25)",
    oem: "3LD-12169-J0-00",
    price: 12.49,
    stock: true
  },
  {
    id: 34,
    name: "PAD, ADJUSTING (2.30)",
    oem: "3LD-12169-L0-00",
    price: 17.99,
    stock: true
  },

  {
    id: 35,
    name: "LIFTER, VALVE",
    oem: "6S5-12153-00-00",
    price: 32.99,
    stock: true
  },
  {
    id: 36,
    name: "CHAIN",
    oem: "94591-74152-00",
    price: 77.99,
    stock: true
  },
  {
    id: 37,
    name: "DAMPER, CHAIN 2",
    oem: "6ET-12252-00-00",
    price: 170.49,
    stock: true
  },
  {
    id: 38,
    name: "PLATE",
    oem: "6BH-12279-00-00",
    price: 122.49,
    stock: true
  },
  {
    id: 39,
    name: "BOLT, FLANGE",
    oem: "95814-06030-00",
    price: 2.99,
    stock: true
  },
  {
    id: 40,
    name: "TENSIONER ASSY, CAM CHAIN",
    oem: "6S5-12210-01-00",
    price: 290.49,
    stock: true
  },
  {
    id: 41,
    name: "GASKET",
    oem: "6S5-121E2-00-00",
    price: 3.49,
    stock: true
  },
  {
    id: 42,
    name: "BOLT",
    oem: "91380-06025-00",
    price: 8.49,
    stock: true
  },
  {
    id: 43,
    name: "PIPE, OIL 2",
    oem: "6S5-13418-00-00",
    price: 57.49,
    stock: true
  },
  {
    id: 44,
    name: "GASKET",
    oem: "90430-10007-00",
    price: 5.49,
    stock: true
  },
  {
    id: 45,
    name: "BOLT, UNION",
    oem: "90401-10040-00",
    price: 9.99,
    stock: true
  },
  {
    id: 46,
    name: "DAMPER, CHAIN 1",
    oem: "6ET-12251-00-00",
    price: 54.99,
    stock: true
  },
  {
    id: 47,
    name: "GUIDE, STOPPER 2",
    oem: "6BH-12241-00-00",
    price: 11.99,
    stock: true
  }
],

"Crankshaft / Pistons": [
  {
    id: 1,
    name: "CRANKSHAFT",
    oem: "6ET-11411-00-00",
    price: 2696.49,
    stock: true
  },

  // CRANK BEARINGS (ALL COLORS — IMPORTANT YOU KEPT THESE 🔥)
  {
    id: 2,
    name: "PLANE BEARING, CRANKSHAFT (BLUE)",
    oem: "6S5-11416-20-00",
    price: 19.99,
    stock: true
  },
  {
    id: 3,
    name: "PLANE BEARING, CRANKSHAFT (BLACK)",
    oem: "6S5-11416-10-00",
    price: 19.99,
    stock: true
  },
  {
    id: 4,
    name: "PLANE BEARING, CRANKSHAFT (BROWN)",
    oem: "6S5-11416-00-00",
    price: 19.99,
    stock: true
  },
  {
    id: 5,
    name: "PLANE BEARING, CRANKSHAFT (YELLOW)",
    oem: "6S5-11416-40-00",
    price: 18.49,
    stock: true
  },
  {
    id: 6,
    name: "PLANE BEARING, CRANKSHAFT (GREEN)",
    oem: "6S5-11416-30-00",
    price: 18.49,
    stock: true
  },

  // PISTON GROUP
  {
    id: 7,
    name: "PISTON (STD)",
    oem: "6BH-11631-00-B0",
    price: 130.99,
    stock: true
  },
  {
    id: 8,
    name: "PISTON RING SET (STD)",
    oem: "6S5-11603-00-00",
    price: 74.99,
    stock: true
  },
  {
    id: 9,
    name: "PIN, PISTON",
    oem: "6S5-11633-00-00",
    price: 30.99,
    stock: true
  },
  {
    id: 10,
    name: "CIRCLIP",
    oem: "93450-24028-00",
    price: 6.49,
    stock: true
  },

  // CONNECTING ROD
  {
    id: 11,
    name: "CONNECTING ROD ASSY",
    oem: "6BH-11650-10-00",
    price: 224.49,
    stock: true
  },
  {
    id: 12,
    name: "BOLT, CONNECTING ROD",
    oem: "6S5-11654-10-00",
    price: 7.99,
    stock: true
  },

  // ROD BEARINGS
  {
    id: 13,
    name: "PLANE BEARING, CONNECTING ROD (BROWN)",
    oem: "6S5-11656-60-00",
    price: 15.99,
    stock: true
  },
  {
    id: 14,
    name: "PLANE BEARING, CONNECTING ROD (GREEN)",
    oem: "6S5-11656-70-00",
    price: 15.99,
    stock: true
  },
  {
    id: 15,
    name: "PLANE BEARING, CONNECTING ROD (BLACK)",
    oem: "6S5-11656-50-00",
    price: 15.99,
    stock: true
  },
  {
    id: 16,
    name: "PLANE BEARING, CONNECTING ROD (BLUE)",
    oem: "6S5-11656-40-00",
    price: 15.99,
    stock: true
  },

  // FINAL COMPONENTS
  {
    id: 17,
    name: "SHAFT, TRANSFER",
    oem: "6S5-17572-01-00",
    price: 310.49,
    stock: true
  },
  {
    id: 18,
    name: "WASHER",
    oem: "6S5-12289-00-00",
    price: 31.99,
    stock: true
  },
  {
    id: 19,
    name: "FLANGE, COUPLING",
    oem: "6S5-45813-01-94",
    price: 120.99,
    stock: true
  },
  {
    id: 20,
    name: "HOLDER",
    oem: "6S5-17525-01-00",
    price: 76.99,
    stock: true
  },
  {
    id: 21,
    name: "NUT, SPECIAL",
    oem: "6S5-11459-01-00",
    price: 37.49,
    stock: true
  },
  {
    id: 22,
    name: "GEAR, TRANSFER DRIVE",
    oem: "6BH-17586-11-00",
    price: 189.49,
    stock: true
  },
  {
    id: 23,
    name: "BOLT",
    oem: "6S5-17031-01-00",
    price: 35.49,
    stock: true
  }
]
}, 

  


Oil: {
"Oil Cooler": [
  {
    id: 1,
    name: "ELEMENT ASSY, OIL CLEANER",
    oem: "69J-13440-03-00",
    price: 31.05,
    stock: true
  },
  {
    id: 2,
    name: "BOLT, UNION",
    oem: "6S5-12858-00-00",
    price: 19.99,
    stock: true
  },
  {
    id: 3,
    name: "OIL COOLER ASSY",
    oem: "6BH-13470-21-00",
    price: 1081.49,
    stock: true
  },
  {
    id: 4,
    name: "GASKET, MANIFOLD",
    oem: "6BH-13556-00-00",
    price: 26.49,
    stock: true
  },
  {
    id: 5,
    name: "PIN, DOWEL",
    oem: "93604-10M03-00",
    price: 5.20,
    stock: true
  },
  {
    id: 6,
    name: "BOLT, FLANGE",
    oem: "90105-06184-00",
    price: 1.99,
    stock: true
  },
  {
    id: 7,
    name: "BOLT, FLANGE",
    oem: "90105-06185-00",
    price: 1.99,
    stock: true
  },
  {
    id: 8,
    name: "GASKET",
    oem: "90430-06232-00",
    price: 1.49,
    stock: true
  },
  {
    id: 9,
    name: "BOLT, FLANGE",
    oem: "90105-08054-00",
    price: 9.49,
    stock: true
  },
  {
    id: 10,
    name: "BOLT, FLANGE",
    oem: "90105-08169-00",
    price: 3.49,
    stock: true
  },
  {
    id: 11,
    name: "BOLT, FLANGE",
    oem: "90105-08170-00",
    price: 8.10,
    stock: true
  },

  
  {
    id: 12,
    name: "CONNECTOR",
    oem: "60E-13446-00-00",
    price: 19.49,
    stock: true
  },



  {
    id: 13,
    name: "O-RING",
    oem: "93210-18322-00",
    price: 5.60,
    stock: true
  }
],




"Oil Pan": [
  {
    id: 1,
    name: "PAN, OIL",
    oem: "6S5-1310A-25-00",
    price: 669.99,
    stock: true
  },
  {
    id: 2,
    name: "OIL PIPE COMP. 1",
    oem: "6S5-13405-11-00",
    price: 167.49,
    stock: true
  },
  {
    id: 3,
    name: "GASKET",
    oem: "6S5-13477-00-00",
    price: 3.99,
    stock: true
  },
  {
    id: 4,
    name: "PLATE, BAFFLE",
    oem: "6S5-13317-10-00",
    price: 12.99,
    stock: true
  },
  {
    id: 5,
    name: "GROMMET",
    oem: "6S5-15486-10-00",
    price: 15.99,
    stock: true
  },
  {
    id: 6,
    name: "BOLT, FLANGE",
    oem: "95817-06014-00",
    price: 2.80,
    stock: true
  },
  {
    id: 7,
    name: "BOLT, HEXAGON SOCKET HEAD",
    oem: "91314-06060-00",
    price: 9.49,
    stock: true
  },
  {
    id: 8,
    name: "WASHER, PLATE",
    oem: "90201-06028-00",
    price: 2.70,
    stock: true
  },
  {
    id: 9,
    name: "BOLT, FLANGE",
    oem: "95814-08020-00",
    price: 9.49,
    stock: true
  },
  {
    id: 10,
    name: "GASKET",
    oem: "90430-08209-00",
    price: 4.05,
    stock: true
  },
  {
    id: 11,
    name: "BOLT, FLANGE (SMALL HEAD)",
    oem: "95024-06035-00",
    price: 10.49,
    stock: true
  },
  {
    id: 12,
    name: "BOLT, FLANGE (SMALL HEAD)",
    oem: "95024-06020-00",
    price: 6.49,
    stock: true
  }
],

"Oil Pump": [
  {
    id: 1,
    name: "OIL PUMP ASSY",
    oem: "6BH-13300-12-00",
    price: 987.99,
    stock: true
  },
  {
    id: 2,
    name: "GASKET",
    oem: "6S5-13563-00-00",
    price: 14.49,
    stock: true
  },
  {
    id: 3,
    name: "PIN, DOWEL",
    oem: "93606-12019-00",
    price: 4.60,
    stock: true
  },
  {
    id: 4,
    name: "BOLT, HEXAGON SOCKET HEAD",
    oem: "90110-06404-00",
    price: 2.65,
    stock: true
  },
  {
    id: 5,
    name: "CONNECTOR",
    oem: "6S5-13446-10-00",
    price: 21.99,
    stock: true
  },
  {
    id: 6,
    name: "O-RING",
    oem: "93210-21631-00",
    price: 8.49,
    stock: true
  },



// continues after id: 6. Breather ASSY
{
  id: 7,
  name: "PIPE, BREATHER 1",
  oem: "6S5-11166-10-00",
  price: 42.99,
  stock: true
},
{
  id: 8,
  name: "TUBE (L410)",
  oem: "90447-22015-00",
  price: 6.99,
  stock: true
},
{
  id: 9,
  name: "CLIP",
  oem: "90467-190A0-00",
  price: 2.49,
  stock: true
},
{
  id: 10,
  name: "PIPE, BREATHER 2",
  oem: "6S5-11167-10-00",
  price: 58.49,
  stock: true
},
{
  id: 11,
  name: "TUBE (L490)",
  oem: "90447-22016-00",
  price: 7.49,
  stock: true
},
{
  id: 12,
  name: "CLIP",
  oem: "90467-240A0-00",
  price: 7.49,
  stock: true
},
{
  id: 13,
  name: "CLIP",
  oem: "90467-200A3-00",
  price: 7.99,
  stock: true
},
{
  id: 14,
  name: "CLIP",
  oem: "90467-190A0-00",
  price: 2.49,
  stock: true
}




]




},

JetPump: [
  {

    // EXTERNAL 

    id: 1,
    name: "PLATE, TRANSOM",
    oem: "6CS-G5831-20-00",
    price: 163.99,
    stock: true
  },
  {
    id: 2,
    name: "PIN, DOWEL",
    oem: "99590-14016-00",
    price: 4.60,
    stock: true
  },
  {
    id: 3,
    name: "BOLT, WITH WASHER",
    oem: "90119-10810-00",
    price: 1.99,
    stock: true
  },
  {
    id: 4,
    name: "HOUSING, IMPELLER",
    oem: "6CR-R1312-00-00",
    price: 195.99,
    stock: true
  },
  {
    id: 5,
    name: "BOLT, WITH WASHER",
    oem: "90119-06893-00",
    price: 1.99,
    stock: true
  },
  {
    id: 6,
    name: "PIN, DOWEL",
    oem: "93606-12019-00",
    price: 4.60,
    stock: true
  },
  {
    id: 7,
    name: "DUCT, IMPELLER",
    oem: "6CR-R1315-00-00",
    price: 139.99,
    stock: true
  },
  {
    id: 8,
    name: "FILTER",
    oem: "6EX-G6882-10-00",
    price: 13.99,
    stock: true
  },
  {
    id: 9,
    name: "O-RING",
    oem: "66V-42414-00-00",
    price: 6.99,
    stock: true
  },
  {
    id: 10,
    name: "BOLT, WITH WASHER",
    oem: "90119-06889-00",
    price: 2.99,
    stock: true
  },

  {
    id: 11,
    name: "BEARING",
    oem: "93306-20654-00",
    price: 83.99,
    stock: true
  },
  {
    id: 12,
    name: "SPACER 1",
    oem: "6CS-G5538-00-00",
    price: 46.99,
    stock: true
  },
  {
    id: 13,
    name: "BEARING",
    oem: "93306-30537-00",
    price: 85.99,
    stock: true
  },
  {
    id: 14,
    name: "OIL SEAL",
    oem: "93102-31009-00",
    price: 80.49,
    stock: true
  },
  {
    id: 15,
    name: "OIL SEAL",
    oem: "93101-31001-00",
    price: 32.99,
    stock: true
  },
  {
    id: 16,
    name: "SHAFT, DRIVE",
    oem: "6S5-45511-00-00",
    price: 352.99,
    stock: true
  },
  {
    id: 17,
    name: "WASHER",
    oem: "92990-20600-00",
    price: 5.49,
    stock: true
  },
  {
    id: 18,
    name: "NUT",
    oem: "95312-20700-00",
    price: 13.99,
    stock: true
  },
  {
    id: 19,
    name: "CAP",
    oem: "6AN-R1326-00-00",
    price: 29.99,
    stock: true
  },
  {
    id: 20,
    name: "O-RING",
    oem: "93210-54010-00",
    price: 2.99,
    stock: true
  },

  {
    id: 21,
    name: "BOLT, HEXAGON SOCKET HEAD",
    oem: "90110-06822-00",
    price: 6.99,
    stock: true
  },
  {
    id: 22,
    name: "IMPELLER",
    oem: "6AP-R1321-20-00",
    price: 234.99,
    stock: true
  },
  {
    id: 23,
    name: "SPACER",
    oem: "6BH-R1348-00-00",
    price: 33.99,
    stock: true
  },
  {
    id: 24,
    name: "O-RING",
    oem: "93210-30611-00",
    price: 14.49,
    stock: true
  },
  {
    id: 25,
    name: "NOZZLE",
    oem: "6EX-R1318-01-00",
    price: 98.99,
    stock: true
  },
  {
    id: 26,
    name: "HOSE 1",
    oem: "6CN-U72M2-00-00",
    price: 10.99,
    stock: true
  },
  {
    id: 27,
    name: "HOSE (L175)",
    oem: "90446-24M46-00",
    price: 5.99,
    stock: true
  },
  {
    id: 28,
    name: "BAND, HOSE (18)",
    oem: "90601-118UF-00",
    price: 6.99,
    stock: true
  },
  {
    id: 29,
    name: "HOSE (L355)",
    oem: "90445-14807-00",
    price: 2.99,
    stock: true
  },
  {
    id: 30,
    name: "HOSE (L320)",
    oem: "90446-20MF5-00",
    price: 4.80,
    stock: true
  },

  {
    id: 31,
    name: "CLAMP",
    oem: "90465-11829-00",
    price: 2.70,
    stock: true
  },
  {
    id: 32,
    name: "PIN, DOWEL",
    oem: "93606-12019-00",
    price: 4.60,
    stock: true
  },
  {
    id: 33,
    name: "BOLT, WITH WASHER",
    oem: "90119-10806-00",
    price: 9.99,
    stock: true
  },
  {
    id: 34,
    name: "BRACKET",
    oem: "6EY-R1959-00-00",
    price: 20.99,
    stock: true
  },
  {
    id: 35,
    name: "NOZZLE, DEFLECTOR",
    oem: "6EX-R1313-00-00",
    price: 29.99,
    stock: true
  },
  {
    id: 36,
    name: "BOLT, WITH WASHER",
    oem: "90119-08840-00",
    price: 2.99,
    stock: true
  },
  {
    id: 37,
    name: "COLLAR",
    oem: "90387-08M06-00",
    price: 12.49,
    stock: true
  },
  {
    id: 38,
    name: "WASHER",
    oem: "F1S-U725E-01-00",
    price: 13.99,
    stock: true
  },
  {
    id: 39,
    name: "WASHER, PLATE",
    oem: "90201-10801-00",
    price: 7.99,
    stock: true
  },
  {
    id: 40,
    name: "NUT, NYLON",
    oem: "9572R-10300-00",
    price: 8.99,
    stock: true
  },

// INTERNAL 

{
  id: 41,
  name: "SHAFT, COUPLER",
  oem: "6S5-R1323-00-00",
  price: 196.99,
  stock: true
},
{
  id: 42,
  name: "O-RING",
  oem: "93210-22MF1-00",
  price: 8.49,
  stock: true
},
{
  id: 43,
  name: "HOUSING, BEARING",
  oem: "6S5-G5332-00-00",
  price: 286.99,
  stock: true
},
{
  id: 44,
  name: "OIL SEAL",
  oem: "93102-29008-00",
  price: 29.99,
  stock: true
},
{
  id: 45,
  name: "CIRCLIP",
  oem: "99009-62500-00",
  price: 9.49,
  stock: true
},
{
  id: 46,
  name: "BEARING",
  oem: "93306-20655-00",
  price: 58.99,
  stock: true
},
{
  id: 47,
  name: "OIL SEAL",
  oem: "93102-29009-00",
  price: 54.99,
  stock: true
},
{
  id: 48,
  name: "WASHER, THRUST",
  oem: "6ET-45613-00-00",
  price: 34.49,
  stock: true
},
{
  id: 49,
  name: "NIPPLE, GREASE",
  oem: "93700-06M03-00",
  price: 8.25,
  stock: true
},
{
  id: 50,
  name: "CAP, GREASE NIPPLE",
  oem: "663-45119-00-00",
  price: 2.40,
  stock: true
},
{
  id: 51,
  name: "FLANGE, COUPLING",
  oem: "6S5-G5593-00-00",
  price: 59.99,
  stock: true
},
{
  id: 52,
  name: "WASHER",
  oem: "6ET-E2289-00-00",
  price: 8.99,
  stock: true
},
{
  id: 53,
  name: "BOLT, WITH WASHER",
  oem: "90119-089UU-00",
  price: 7.99,
  stock: true
},
{
  id: 54,
  name: "BOLT, WITH WASHER",
  oem: "90119-06891-00",
  price: 10.99,
  stock: true
},
{
  id: 55,
  name: "COVER",
  oem: "6S5-R1381-01-00",
  price: 7.99,
  stock: true
},
{
  id: 56,
  name: "RUBBER SHAFT COUPLING",
  oem: "6BH-4581J-00-00",
  price: 137.49,
  stock: true
},
{
  id: 57,
  name: "PIN, DOWEL",
  oem: "93606-12019-00",
  price: 4.60,
  stock: true
},
{
  id: 58,
  name: "COLLAR",
  oem: "90387-06289-00",
  price: 3.18,
  stock: true
},
{
  id: 59,
  name: "JOINT, PIPE",
  oem: "F2N-U883E-00-00",
  price: 13.99,
  stock: true
},
{
  id: 60,
  name: "BOLT",
  oem: "90109-06832-00",
  price: 7.99,
  stock: true
},
{
  id: 61,
  name: "BAND, HOSE (55)",
  oem: "90601-155U4-00",
  price: 11.99,
  stock: true
},
{
  id: 62,
  name: "PIPE",
  oem: "F2M-U883B-00-00",
  price: 30.99,
  stock: true
},
{
  id: 63,
  name: "FLOTATION, STERN",
  oem: "F1K-U892D-00-00",
  price: 31.99,
  stock: true
}


],


  // ✅ NEW CORRECT SECTION
  Intake: [

{
  id: 1,
  name: "THROTTLE BODY ASSY",
  oem: "6BH-13750-10-00",
  price: 1866.99,
  stock: true
},
{
  id: 2,
  name: "WIRE, SUB LEAD",
  oem: "6S5-82509-00-00",
  price: 118.99,
  stock: true
},
{
  id: 3,
  name: "MANIFOLD, INTAKE 1",
  oem: "6BH-13641-10-00",
  price: 384.99,
  stock: true
},
{
  id: 4,
  name: "GASKET, INSULATING",
  oem: "6BH-14156-00-00",
  price: 19.49,
  stock: true
},
{
  id: 5,
  name: "GASKET",
  oem: "6BH-14126-00-00",
  price: 16.99,
  stock: true
},
{
  id: 6,
  name: "DELIVERY PIPE",
  oem: "6CS-12880-00-00",
  price: 167.49,
  stock: true
},
{
  id: 7,
  name: "BOLT, FLANGE",
  oem: "90105-08243-00",
  price: 1.99,
  stock: true
},
{
  id: 8,
  name: "BOLT",
  oem: "6CS-14446-00-00",
  price: 9.99,
  stock: true
},
{
  id: 9,
  name: "BOLT, WITH WASHER",
  oem: "97513-08525-00",
  price: 9.49,
  stock: true
},
{
  id: 10,
  name: "SENSOR, PRESSURE",
  oem: "6BH-82380-00-00",
  price: 282.99,
  stock: true
},
{
  id: 11,
  name: "GASKET",
  oem: "6CR-14536-00-00",
  price: 11.99,
  stock: true
},
{
  id: 12,
  name: "SPACER",
  oem: "6CR-14163-00-00",
  price: 74.99,
  stock: true
},
{
  id: 13,
  name: "INJECTOR",
  oem: "6S5-13761-10-00",
  price: 215.99,
  stock: true
},
{
  id: 14,
  name: "O-RING",
  oem: "68V-1416A-00-00",
  price: 13.75,
  stock: true
},
{
  id: 15,
  name: "GASKET, MANIFOLD",
  oem: "8FP-13556-10-00",
  price: 7.49,
  stock: true
},
{
  id: 16,
  name: "RIBBON",
  oem: "6D3-1444B-00-00",
  price: 100.49,
  stock: true
},
{
  id: 17,
  name: "THERMOSENSOR",
  oem: "65L-85886-00-00",
  price: 77.25,
  stock: true
},
{
  id: 18,
  name: "WASHER",
  oem: "6S5-14285-00-00",
  price: 2.49,
  stock: true
},
{
  id: 19,
  name: "HOLDER",
  oem: "6S5-14457-00-00",
  price: 78.49,
  stock: true
},
{
  id: 20,
  name: "GROMMET",
  oem: "6BH-14445-00-00",
  price: 20.99,
  stock: true
},
{
  id: 21,
  name: "HOSE, VACUUM SENSING 3",
  oem: "6BH-13532-00-00",
  price: 6.99,
  stock: true
},
{
  id: 22,
  name: "FUEL HOSE ASSY",
  oem: "6CN-2450B-10-00",
  price: 131.99,
  stock: true
},
{
  id: 23,
  name: "BOLT, WITH WASHER",
  oem: "97513-08535-00",
  price: 1.99,
  stock: true
},
{
  id: 24,
  name: "BOLT, STUD",
  oem: "90116-08032-00",
  price: 4.49,
  stock: true
},
{
  id: 25,
  name: "NUT, CROWN",
  oem: "90176-08080-00",
  price: 4.65,
  stock: true
},
{
  id: 26,
  name: "PLATE, STAY",
  oem: "6CR-14572-00-00",
  price: 7.99,
  stock: true
},
{
  id: 27,
  name: "GROMMET",
  oem: "6CS-14445-00-00",
  price: 5.99,
  stock: true
},
{
  id: 28,
  name: "BOLT",
  oem: "95023-06012-00",
  price: 4.75,
  stock: true
},
    


// continues after id: 28
{
  id: 29,
  name: "GROMMET",
  oem: "90480-22M15-00",
  price: 13.75,
  stock: true
},
{
  id: 30,
  name: "COLLAR",
  oem: "90387-08M37-00",
  price: 11.40,
  stock: true
},
{
  id: 31,
  name: "BOLT, WITH WASHER",
  oem: "90119-08M22-00",
  price: 3.49,
  stock: true
},
{
  id: 32,
  name: "HOSE CLAMP ASSY",
  oem: "90450-90002-00",
  price: 16.99,
  stock: true
},
{
  id: 33,
  name: "HOSE CLAMP ASSY",
  oem: "90450-90002-00",
  price: 16.99,
  stock: true
},
{
  id: 34,
  name: "AIR CLEANER ASSY.",
  oem: "6S5-E4410-01-00",
  price: 208.99,
  stock: true
},
{
  id: 35,
  name: "ELEMENT, AIR CLEANER",
  oem: "6S5-E4451-00-00",
  price: 219.99,
  stock: true
},
{
  id: 36,
  name: "HOOK",
  oem: "6S5-E4436-00-00",
  price: 8.99,
  stock: true
},
{
  id: 37,
  name: "RUBBER, SEAL 2",
  oem: "6S5-G2717-00-00",
  price: 7.99,
  stock: true
},
{
  id: 38,
  name: "SCREW, TAPPING",
  oem: "97780-60516-00",
  price: 2.70,
  stock: true
},
{
  id: 39,
  name: "GROMMET",
  oem: "90480-22801-00",
  price: 7.99,
  stock: true
},
{
  id: 40,
  name: "PIPE",
  oem: "6BH-E4419-00-00",
  price: 59.99,
  stock: true
},
{
  id: 41,
  name: "CONNECTION",
  oem: "6BH-R1142-10-00",
  price: 6.99,
  stock: true
},
{
  id: 42,
  name: "CLAMP",
  oem: "90464-40825-00",
  price: 3.05,
  stock: true
}






  ],





   Electrical: {
    Main: [
   {
  id: 1,
  name: "BOLT, WITH WASHER",
  oem: "90119-089UT-00",
  price: 7.99,
  stock: true
},
{
  id: 2,
  name: "BOLT, WITH WASHER",
  oem: "90119-089UT-00",
  price: 7.99,
  stock: true
},
{
  id: 3,
  name: "PLATE",
  oem: "6CS-81845-10-00",
  price: 88.49,
  stock: true
},
{
  id: 4,
  name: "COVER",
  oem: "6S5-81942-20-00",
  price: 88.49,
  stock: true
},
{
  id: 5,
  name: "LABEL, CAUTION 7",
  oem: "60E-83627-00-00",
  price: 4.99,
  stock: true
},
{
  id: 6,
  name: "ENGINE CONTROL UNIT ASSY",
  oem: "6CR-8591A-30-00",
  price: 2065.99,
  stock: true
},
{
  id: 7,
  name: "BOLT, FLANGE",
  oem: "95814-06012-00",
  price: 2.49,
  stock: true
},
{
  id: 8,
  name: "GROMMET, ECU",
  oem: "6EY-8591S-00-00",
  price: 24.99,
  stock: true
},
{
  id: 9,
  name: "BRACKET",
  oem: "6ET-81948-00-00",
  price: 27.49,
  stock: true
},
{
  id: 10,
  name: "FUSE BOX ASSY",
  oem: "6EX-82170-01-00",
  price: 266.49,
  stock: true
},
{
  id: 11,
  name: "FUSE (3A)",
  oem: "67F-82151-30-00",
  price: 5.49,
  stock: true
},
{
  id: 12,
  name: "FUSE (10A)",
  oem: "67F-82151-40-00",
  price: 7.10,
  stock: true
},
{
  id: 13,
  name: "FUSE (20A)",
  oem: "67F-82151-00-00",
  price: 8.49,
  stock: true
},
{
  id: 14,
  name: "FUSE (30A)",
  oem: "67F-82151-10-00",
  price: 8.49,
  stock: true
},
{
  id: 15,
  name: "FUSE (50A)",
  oem: "6EX-82151-00-00",
  price: 3.99,
  stock: true
},
{
  id: 16,
  name: "RELAY ASSY",
  oem: "6EX-8195A-00-00",
  price: 20.99,
  stock: true
},
{
  id: 17,
  name: "PULLER, FUSE",
  oem: "6EX-2812A-00-00",
  price: 1.49,
  stock: true
},
{
  id: 18,
  name: "BOLT, WITH WASHER",
  oem: "90119-06M88-00",
  price: 1.99,
  stock: true
},
{
  id: 19,
  name: "DAMPER, IGNITION COIL",
  oem: "6A0-82317-00-00",
  price: 7.10,
  stock: true
},
{
  id: 20,
  name: "COLLAR",
  oem: "90387-06119-00",
  price: 4.80,
  stock: true
},
{
  id: 21,
  name: "SENSOR, LEAN ANGLE",
  oem: "6ET-82576-00-00",
  price: 67.49,
  stock: true
},
{
  id: 22,
  name: "SCREW, TAPPING",
  oem: "97780-60025-00",
  price: 5.99,
  stock: true
},
{
  id: 23,
  name: "COLLAR",
  oem: "90387-06M05-00",
  price: 8.70,
  stock: true
},
{
  id: 24,
  name: "WIRE, PLUS LEAD",
  oem: "6CS-82115-00-00",
  price: 47.99,
  stock: true
},
{
  id: 25,
  name: "WIRE, LEAD",
  oem: "6CS-82117-00-00",
  price: 72.99,
  stock: true
},
{
  id: 26,
  name: "STARTER RELAY ASSY (2768102-A)",
  oem: "1B7-81940-00-00",
  price: 137.99,
  stock: true
},
{
  id: 27,
  name: "BOLT",
  oem: "97095-06012-00",
  price: 2.99,
  stock: true
},
{
  id: 28,
  name: "WASHER, SPRING",
  oem: "92995-06100-00",
  price: 3.45,
  stock: true
},
{
  id: 29,
  name: "WASHER",
  oem: "92995-06600-00",
  price: 2.85,
  stock: true
},
{
  id: 30,
  name: "STAY, RELAY",
  oem: "6CS-81953-00-00",
  price: 5.99,
  stock: true
},
{
  id: 31,
  name: "BOLT, FLANGE",
  oem: "95814-06012-00",
  price: 2.49,
  stock: true
},
{
  id: 32,
  name: "WIRE HARNESS ASSY 1",
  oem: "6FG-8259L-10-00",
  price: 1286.99,
  stock: true
},
{
  id: 33,
  name: "COVER, CONNECTOR",
  oem: "6EM-82599-00-00",
  price: 6.85,
  stock: true
},
{
  id: 34,
  name: "CLAMP",
  oem: "90465-14M66-00",
  price: 4.95,
  stock: true
},
{
  id: 35,
  name: "BAND",
  oem: "90601-200U2-00",
  price: 8.99,
  stock: true
},
{
  id: 36,
  name: "TRIM 1",
  oem: "F1S-U828H-01-00",
  price: 12.99,
  stock: true
},
{
  id: 37,
  name: "BASE, CLAMP",
  oem: "F1W-U828M-00-00",
  price: 5.99,
  stock: true
},
{
  id: 38,
  name: "RIVET, BLIND",
  oem: "90267-48802-00",
  price: 6.99,
  stock: true
},
{
  id: 39,
  name: "CLAMP",
  oem: "90464-32801-00",
  price: 5.99,
  stock: true
},

{
  id: 40,
  name: "RECTIFIER & REGULATOR ASSY",
  oem: "6EK-81960-02-00",
  price: 197.40,
  stock: true
},
{
  id: 41,
  name: "PLATE, RECTIFIER FITTING",
  oem: "6ET-81975-01-00",
  price: 6.99,
  stock: true
},
{
  id: 42,
  name: "COVER, RECTIFIER",
  oem: "6ET-81972-00-00",
  price: 117.99,
  stock: true
},
{
  id: 43,
  name: "BOLT, WITH WASHER",
  oem: "90119-06MA4-00",
  price: 4.40,
  stock: true
},
{
  id: 44,
  name: "COLLAR",
  oem: "90387-08M37-00",
  price: 11.40,
  stock: true
},
{
  id: 45,
  name: "BOLT, WITH WASHER",
  oem: "90119-08M22-00",
  price: 3.49,
  stock: true
},
{
  id: 46,
  name: "GROMMET",
  oem: "90480-22M15-00",
  price: 13.75,
  stock: true
},
{
  id: 47,
  name: "IGNITION COIL ASSY",
  oem: "6S5-82310-00-00",
  price: 403.99,
  stock: true
},
{
  id: 48,
  name: "BOLT, FLANGE",
  oem: "90105-06903-00",
  price: 10.49,
  stock: true
},
{
  id: 49,
  name: "PLUG, SPARK (NGK LFR6A)",
  oem: "LFR-6A000-00-00",
  price: 10.99,
  stock: true
},
{
  id: 50,
  name: "CLAMP",
  oem: "90464-35132-00",
  price: 10.49,
  stock: true
},
{
  id: 51,
  name: "THERMOSENSOR ASSY",
  oem: "61A-85790-00-00",
  price: 144.10,
  stock: true
},
{
  id: 52,
  name: "WASHER, PLATE",
  oem: "92990-10600-00",
  price: 3.00,
  stock: true
},
{
  id: 53,
  name: "THERMO SWITCH ASSY",
  oem: "6CR-82560-00-00",
  price: 96.99,
  stock: true
},
{
  id: 54,
  name: "BOLT",
  oem: "97095-06016-00",
  price: 2.76,
  stock: true
},
{
  id: 55,
  name: "WASHER",
  oem: "92995-06600-00",
  price: 2.85,
  stock: true
},
{
  id: 56,
  name: "SENSOR, CAM POSITION",
  oem: "60E-85896-01-00",
  price: 160.99,
  stock: true
},
{
  id: 57,
  name: "BOLT",
  oem: "91380-06016-00",
  price: 7.49,
  stock: true
},
{
  id: 58,
  name: "OIL PRESSURE SWITCH ASSY",
  oem: "68V-82504-00-00",
  price: 84.90,
  stock: true
},
{
  id: 59,
  name: "LEAD WIRE ASSY",
  oem: "6S5-81315-00-00",
  price: 51.99,
  stock: true
},
{
  id: 60,
  name: "EARTH PLATE COMP.",
  oem: "6CS-8273J-10-00",
  price: 182.99,
  stock: true
},
{
  id: 61,
  name: "O-RING",
  oem: "93210-32172-00",
  price: 8.49,
  stock: true
},
{
  id: 62,
  name: "BOLT, WITH WASHER",
  oem: "90119-06MA3-00",
  price: 3.20,
  stock: true
},
{
  id: 63,
  name: "CLAMP",
  oem: "90464-20008-00",
  price: 4.00,
  stock: true
},
{
  id: 64,
  name: "THERMOSENSOR ASSY",
  oem: "6AA-85790-00-00",
  price: 136.49,
  stock: true
},
{
  id: 65,
  name: "CLAMP",
  oem: "90464-31001-00",
  price: 2.49,
  stock: true
},
{
  id: 66,
  name: "CLAMP",
  oem: "90464-31002-00",
  price: 4.82,
  stock: true
},

],


"Ignition": [
  {
    id: 1,
    name: "STARTING MOTOR ASSY",
    oem: "6S5-81800-00-00",
    price: 800.99,
    stock: true
  },
  {
    id: 2,
    name: "GASKET",
    oem: "11H-81844-00-00",
    price: 53.99,
    stock: true
  },
  {
    id: 3,
    name: "FRONT BRACKET ASSY",
    oem: "6S5-81830-00-00",
    price: 272.99,
    stock: true
  },
  {
    id: 4,
    name: "GASKET",
    oem: "4G0-81844-00-00",
    price: 32.99,
    stock: true
  },
  {
    id: 5,
    name: "O-RING",
    oem: "1J7-81847-60-00",
    price: 42.99,
    stock: true
  },
  {
    id: 6,
    name: "GEAR, STARTING MOTOR",
    oem: "5EL-15511-00-00",
    price: 101.49,
    stock: true
  },
  {
    id: 7,
    name: "CIRCLIP",
    oem: "93410-12003-00",
    price: 3.59,
    stock: true
  },
  {
    id: 8,
    name: "BRUSH HOLDER ASSY",
    oem: "6S5-81840-00-00",
    price: 77.99,
    stock: true
  },
  {
    id: 9,
    name: "O-RING",
    oem: "3TB-81847-00-00",
    price: 2.49,
    stock: true
  },
  {
    id: 10,
    name: "BOLT",
    oem: "6S5-81826-00-00",
    price: 43.99,
    stock: true
  },
  {
    id: 11,
    name: "PLATE",
    oem: "5EL-81845-00-00",
    price: 40.99,
    stock: true
  },
  {
    id: 12,
    name: "REAR BRACKET ASSY",
    oem: "6S5-81820-00-00",
    price: 174.99,
    stock: true
  },
  {
    id: 13,
    name: "STATOR ASSY",
    oem: "6S5-81810-00-00",
    price: 207.49,
    stock: true
  },
  {
    id: 14,
    name: "ARMATURE ASSY",
    oem: "5A8-81850-10-00",
    price: 363.99,
    stock: true
  },
  {
    id: 15,
    name: "BOLT",
    oem: "97013-08030-00",
    price: 3.80,
    stock: true
  },
  {
    id: 16,
    name: "WASHER, PLATE",
    oem: "92903-08600-00",
    price: 2.70,
    stock: true
  },
  {
    id: 17,
    name: "WASHER, SPRING",
    oem: "92990-06100-00",
    price: 3.45,
    stock: true
  },
  {
    id: 18,
    name: "NUT",
    oem: "95380-06700-00",
    price: 9.49,
    stock: true
  },

],




  "Charging": [
  {
    id: 1,
    name: "STARTER ONE-WAY ASSY",
    oem: "6S5-15590-00-00",
    price: 273.99,
    stock: true
  },
  {
    id: 2,
    name: "BOLT, HEXAGON SOCKET HEAD",
    oem: "90110-08212-00",
    price: 3.05,
    stock: true
  },
  {
    id: 3,
    name: "GEAR 3",
    oem: "6S5-15515-00-00",
    price: 349.99,
    stock: true
  },
  {
    id: 4,
    name: "SHAFT 1",
    oem: "6S5-15521-00-00",
    price: 10.49,
    stock: true
  },
  {
    id: 5,
    name: "GEAR, IDLER 2",
    oem: "6S5-15517-00-00",
    price: 153.99,
    stock: true
  },
  {
    id: 6,
    name: "ROTOR ASSY",
    oem: "6S5-81450-01-00",
    price: 489.49,
    stock: true
  },
  {
    id: 7,
    name: "STATOR ASSY",
    oem: "6ET-81410-00-00",
    price: 336.95,
    stock: true
  },
  {
    id: 8,
    name: "SCREW",
    oem: "90149-06229-00",
    price: 9.49,
    stock: true
  },
  {
    id: 9,
    name: "BOLT, WITH WASHER",
    oem: "97513-05514-00",
    price: 3.99,
    stock: true
  },
  {
    id: 10,
    name: "KEY, WOODRUFF",
    oem: "90280-03047-00",
    price: 6.49,
    stock: true
  },
  {
    id: 11,
    name: "COVER, FLYWHEEL",
    oem: "6S5-81337-31-00",
    price: 267.49,
    stock: true
  },
  {
    id: 12,
    name: "BEARING",
    oem: "93306-00809-00",
    price: 65.49,
    stock: true
  },
  {
    id: 13,
    name: "OIL SEAL",
    oem: "6S5-81167-10-00",
    price: 73.99,
    stock: true
  },
  {
    id: 14,
    name: "CIRCLIP",
    oem: "99009-72500-00",
    price: 8.99,
    stock: true
  },
  {
    id: 15,
    name: "BOLT, FLANGE",
    oem: "90105-08249-00",
    price: 2.49,
    stock: true
  },
  {
    id: 16,
    name: "PIN, DOWEL",
    oem: "99530-10114-00",
    price: 2.65,
    stock: true
  },
  {
    id: 17,
    name: "O-RING",
    oem: "6S5-81168-00-00",
    price: 42.99,
    stock: true
  },
  {
    id: 18,
    name: "CLAMP",
    oem: "6S5-81328-00-00",
    price: 8.49,
    stock: true
  },
  {
    id: 19,
    name: "BOLT, HEXAGON SOCKET HEAD",
    oem: "91317-06014-00",
    price: 10.49,
    stock: true
  },
  {
    id: 20,
    name: "BOLT, HEXAGON SOCKET HEAD",
    oem: "91317-05010-00",
    price: 2.75,
    stock: true
  },
  {
    id: 21,
    name: "WASHER, PLATE",
    oem: "90201-052E8-00",
    price: 5.49,
    stock: true
  },
  {
    id: 22,
    name: "COLLAR",
    oem: "90387-06M05-00",
    price: 8.70,
    stock: true
  },
  {
    id: 23,
    name: "BOLT",
    oem: "91380-06020-00",
    price: 6.10,
    stock: true
  },
  {
    id: 24,
    name: "GROMMET",
    oem: "6S5-81364-10-00",
    price: 5.49,
    stock: true
  }


         ]
  },




 Reverse: [
  { id: 1, name: "MOTOR ASSY.", oem: "F2X-6140B-03-00", price: 2400.99, stock: true },
  { id: 2, name: "HOUSING", oem: "F3J-6152K-10-00", price: 192.99, stock: true },
  { id: 3, name: "SEAL", oem: "F3J-63262-00-00", price: 18.49, stock: true },
  { id: 4, name: "PLUG", oem: "F3J-613D0-00-00", price: 11.99, stock: true },
  { id: 5, name: "BOLT, STUD", oem: "F3J-67369-00-00", price: 6.99, stock: true },
  { id: 6, name: "COVER", oem: "F3J-6143J-00-00", price: 50.99, stock: true },
  { id: 7, name: "SCREW", oem: "F3J-68198-00-00", price: 3.99, stock: true },
  { id: 8, name: "CONTROL UNIT", oem: "F2X-68197-00-00", price: 615.99, stock: true },
  { id: 9, name: "COLLAR", oem: "90387-06119-00", price: 4.80, stock: true },
  { id: 10, name: "DAMPER, IGNITION COIL", oem: "6A0-82317-00-00", price: 7.10, stock: true },
  { id: 11, name: "BOLT", oem: "F3J-613B4-20-00", price: 4.99, stock: true },
  { id: 12, name: "PLATE", oem: "F3J-61256-00-00", price: 29.99, stock: true },
  { id: 13, name: "BOLT, HEXAGON", oem: "F3J-613B3-00-00", price: 3.99, stock: true },
  { id: 14, name: "SCREW", oem: "F3J-68198-20-00", price: 3.99, stock: true },
  { id: 15, name: "WASHER, PLAIN", oem: "F3J-613C3-10-00", price: 4.99, stock: true },
  { id: 16, name: "MAGNET, SENSOR", oem: "F3J-60428-00-00", price: 25.49, stock: true },
  { id: 17, name: "SENSOR ASSY 1", oem: "F2X-6E571-00-00", price: 209.99, stock: true },
  { id: 18, name: "WIRE HARNESS ASSY", oem: "F2X-68270-00-00", price: 349.99, stock: true },
  { id: 19, name: "SCREW", oem: "F3J-68198-10-00", price: 3.99, stock: true },
  { id: 20, name: "CLAMP, WIRE", oem: "F3J-68273-00-00", price: 3.49, stock: true },
  { id: 21, name: "CLAMP, WIRE", oem: "F3J-68273-00-00", price: 3.49, stock: true },
  { id: 22, name: "CLAMP, WIRE", oem: "F3J-68273-00-00", price: 3.49, stock: true },
  { id: 23, name: "MOTOR", oem: "F3J-68352-00-00", price: 278.49, stock: true },
  { id: 24, name: "BOLT", oem: "F3J-613B4-00-00", price: 4.99, stock: true },
  { id: 25, name: "WASHER, PLAIN", oem: "F3J-613C3-00-00", price: 3.99, stock: true },
  { id: 26, name: "PLATE", oem: "F3J-61348-00-00", price: 4.99, stock: true },
  { id: 27, name: "SCREW", oem: "F3J-68198-20-00", price: 3.99, stock: true },
  { id: 28, name: "SHAFT 1", oem: "F3J-60221-00-00", price: 177.49, stock: true },
  { id: 29, name: "BUSH", oem: "F3J-61344-00-00", price: 4.49, stock: true },
  { id: 30, name: "O-RING", oem: "F3J-613A5-00-00", price: 3.99, stock: true },
  { id: 31, name: "PLATE", oem: "F3Y-U8285-00-00", price: 19.99, stock: true },
  { id: 32, name: "BOLT, HEXAGON SOCKET HEAD", oem: "90110-06040-00", price: 3.49, stock: true },
  { id: 33, name: "BOLT, WITH WASHER", oem: "90119-08851-00", price: 8.99, stock: true },
  { id: 34, name: "NUT, LOCK", oem: "F3Y-U142L-00-00", price: 6.99, stock: true },
  { id: 35, name: "SHIFT ARM ASSY", oem: "F3J-6150F-00-00", price: 68.49, stock: true },
  { id: 36, name: "ROD ASSY 2", oem: "F3J-6150D-00-00", price: 51.99, stock: true },


{
  id: 37,
  name: "GATE, REVERSE",
  oem: "6ET-R1314-10-00",
  price: 45.99,
  stock: true
},
{
  id: 38,
  name: "BOLT, WITH WASHER",
  oem: "90119-08840-00",
  price: 2.99,
  stock: true
},
{
  id: 39,
  name: "COLLAR",
  oem: "90387-08M30-00",
  price: 9.99,
  stock: true
},
{
  id: 40,
  name: "BOLT, WITH WASHER",
  oem: "90119-069UX-00",
  price: 7.99,
  stock: true
},
{
  id: 41,
  name: "COLLAR",
  oem: "90387-06319-00",
  price: 7.99,
  stock: true
},
{
  id: 42,
  name: "WASHER, PLATE",
  oem: "90201-06801-00",
  price: 10.49,
  stock: true
},
{
  id: 43,
  name: "NUT, HEXAGON",
  oem: "95380-06600-00",
  price: 4.80,
  stock: true
},
{
  id: 44,
  name: "SPRING, RETAINER",
  oem: "6S5-R2358-00-00",
  price: 6.99,
  stock: true
},
{
  id: 45,
  name: "WASHER, PLATE",
  oem: "90201-06801-00",
  price: 10.49,
  stock: true
},
{
  id: 46,
  name: "NUT, HEXAGON",
  oem: "95380-06600-00",
  price: 4.80,
  stock: true
},
{
  id: 47,
  name: "STUD, JOINT BALL",
  oem: "6GA-U1461-10-00",
  price: 6.99,
  stock: true
},
{
  id: 48,
  name: "BRACKET 1",
  oem: "6ET-R1341-10-00",
  price: 27.99,
  stock: true
},
{
  id: 49,
  name: "BRACKET 2",
  oem: "6ET-R1342-10-00",
  price: 27.99,
  stock: true
},
{
  id: 50,
  name: "BOLT, WITH WASHER",
  oem: "90119-06891-00",
  price: 10.99,
  stock: true
}


],





Graphics: [
  {
    id: 1,
    name: "GRAPHIC 1 (LEFT HAND) (DNMC - DARK GRAY METALLIC)",
    oem: "F4E-U417B-50-00",
    price: 33.99,
    stock: true
  },
  {
    id: 2,
    name: "GRAPHIC 1 (LEFT HAND) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F4E-U417B-60-00",
    price: 181.99,
    stock: true
  },
  {
    id: 3,
    name: "GRAPHIC 2 (RIGHT HAND) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F4E-U417C-60-00",
    price: 183.99,
    stock: true
  },
  {
    id: 4,
    name: "GRAPHIC 2 (RIGHT HAND) (DNMC - DARK GRAY METALLIC)",
    oem: "F4E-U417C-50-00",
    price: 33.99,
    stock: true
  },
  {
    id: 5,
    name: "GRAPHIC 3 (LEFT HAND) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F4E-U417D-60-00",
    price: 15.99,
    stock: true
  },
  {
    id: 6,
    name: "GRAPHIC 3 (LEFT HAND) (DNMC - DARK GRAY METALLIC)",
    oem: "F4E-U417D-50-00",
    price: 15.99,
    stock: true
  },
  {
    id: 7,
    name: "GRAPHIC 4 (RIGHT HAND) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F4E-U417E-60-00",
    price: 15.99,
    stock: true
  },
  {
    id: 8,
    name: "GRAPHIC 4 (RIGHT HAND) (DNMC - DARK GRAY METALLIC)",
    oem: "F4E-U417E-50-00",
    price: 155.99,
    stock: true
  },
  {
    id: 9,
    name: "GRAPHIC 7 (LEFT HAND) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F4E-U417H-60-00",
    price: 33.99,
    stock: true
  },
  {
    id: 10,
    name: "GRAPHIC 7 (LEFT HAND) (DNMC - DARK GRAY METALLIC)",
    oem: "F4E-U417H-50-00",
    price: 33.99,
    stock: true
  },
  {
    id: 11,
    name: "GRAPHIC 8 (RIGHT HAND) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F4E-U417J-60-00",
    price: 199.99,
    stock: true
  },
  {
    id: 12,
    name: "GRAPHIC 8 (RIGHT HAND) (DNMC - DARK GRAY METALLIC)",
    oem: "F4E-U417J-50-00",
    price: 183.99,
    stock: true
  },
  {
    id: 13,
    name: "GRAPHIC 9 (LEFT HAND) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F4E-U417K-60-00",
    price: 8.99,
    stock: true
  },
  {
    id: 14,
    name: "GRAPHIC 9 (LEFT HAND) (DNMC - DARK GRAY METALLIC)",
    oem: "F4E-U417K-50-00",
    price: 8.99,
    stock: true
  },
  {
    id: 15,
    name: "GRAPHIC (B) (RIGHT HAND) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F4E-U417L-60-00",
    price: 8.99,
    stock: true
  },
  {
    id: 16,
    name: "GRAPHIC (B) (RIGHT HAND) (DNMC - DARK GRAY METALLIC)",
    oem: "F4E-U417L-50-00",
    price: 149.99,
    stock: true
  },
  {
    id: 17,
    name: "EMBLEM, YAMAHA (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F2P-U411C-00-00",
    price: 69.99,
    stock: true
  },
  {
    id: 18,
    name: "EMBLEM, YAMAHA (DNMC - DARK GRAY METALLIC)",
    oem: "F2P-U411C-10-00",
    price: 27.99,
    stock: true
  },
  {
    id: 19,
    name: "MARK, YAMAHA (A) (DPBM11 - DARK PURPLISH BULE METALLIC)",
    oem: "F2P-U4114-00-00",
    price: 68.99,
    stock: true
  },
  {
    id: 20,
    name: "MARK, YAMAHA (A) (DNMC - DARK GRAY METALLIC)",
    oem: "F2P-U4114-10-00",
    price: 8.99,
    stock: true
  },
  {
    id: 21,
    name: "EMBLEM, TUNING FORK",
    oem: "F3Y-U411H-02-00",
    price: 19.99,
    stock: true
  },
  {
    id: 22,
    name: "EMBLEM (A)",
    oem: "F1W-U4121-00-00",
    price: 7.99,
    stock: true
  },
  {
    id: 23,
    name: "TOOL SET",
    oem: "F1B-65986-13-00",
    price: 52.99,
    stock: true
  },
  {
    id: 24,
    name: "BAG, VINYL",
    oem: "F3Y-U5901-00-00",
    price: 4.99,
    stock: true
  },



{
  id: 25,
  name: "LABEL, WARNING UNIFORM 1",
  oem: "F2X-U41B1-10-00",
  price: 41.99,
  stock: true
},
{
  id: 26,
  name: "LABEL, WARNING(FUEL)",
  oem: "F1S-U415B-01-00",
  price: 11.99,
  stock: true
},
{
  id: 27,
  name: "LABEL, WARNING BATTERY",
  oem: "F0V-U41DB-02-00",
  price: 53.99,
  stock: true
},
{
  id: 28,
  name: "LABEL, FIRE EXTINGUISHER 1 (DNMC - DARK GRAY METALLIC)",
  oem: "F0V-U41F5-01-00",
  price: 7.99,
  stock: true
},
{
  id: 29,
  name: "LABEL, FIRE EXTINGUISHER 1 (DPBM11 - DARK PURPLISH BULE METALLIC)",
  oem: "F1B-U41F5-01-00",
  price: 25.99,
  stock: true
},
{
  id: 30,
  name: "LABEL, SET 1",
  oem: "F4E-U41E1-00-00",
  price: 109.99,
  stock: true
}


  
],



Steering: [

  {
    id: 1,
    name: "CABLE, STEERING",
    oem: "F2N-61481-00-00",
    price: 499.49,
    stock: true
  },
  {
    id: 2,
    name: "PACKING (C)",
    oem: "F1B-61438-00-00",
    price: 2.99,
    stock: true
  },
  {
    id: 3,
    name: "NUT",
    oem: "F1B-6151S-00-00",
    price: 14.49,
    stock: true
  },
  {
    id: 4,
    name: "STUD, JOINT BALL",
    oem: "F1B-61461-02-00",
    price: 95.99,
    stock: true
  },
  {
    id: 5,
    name: "BALL JOINT ASSY",
    oem: "F2N-61460-00-00",
    price: 48.49,
    stock: true
  },
  {
    id: 6,
    name: "WASHER, PLATE",
    oem: "90201-06906-00",
    price: 3.49,
    stock: true
  },
  {
    id: 7,
    name: "NUT",
    oem: "9538R-06700-00",
    price: 5.99,
    stock: true
  },


{
  id: 8,
  name: "PAD, STEERING 1",
  oem: "F2X-U143D-10-00",
  price: 62.99,
  stock: true
},
{
  id: 9,
  name: "PAD, STEERING 2",
  oem: "F2X-U143E-10-00",
  price: 52.99,
  stock: true
},
{
  id: 10,
  name: "COVER, PAD (DPBM11 - DARK PURPLISH BULE METALLIC)",
  oem: "F2X-U142D-20-00",
  price: 41.99,
  stock: true
},
{
  id: 11,
  name: "COVER, PAD (DNMC - DARK GRAY METALLIC)",
  oem: "F2X-U142D-40-00",
  price: 203.99,
  stock: true
},
{
  id: 12,
  name: "PAD 1",
  oem: "F2X-U156E-00-00",
  price: 39.99,
  stock: true
},
{
  id: 13,
  name: "SCREW, BINDING",
  oem: "90154-06017-00",
  price: 1.49,
  stock: true
},
{
  id: 14,
  name: "SCREW",
  oem: "90149-05903-00",
  price: 3.55,
  stock: true
},


{
  id: 15,
  name: "HANDLE",
  oem: "F2X-U1552-00-00",
  price: 80.99,
  stock: true
},
{
  id: 16,
  name: "GRIP, HANDLE",
  oem: "F2S-U155D-02-00",
  price: 44.99,
  stock: true
},
{
  id: 17,
  name: "BOLT, HEXAGON SOCKET HEAD",
  oem: "90110-06382-00",
  price: 4.99,
  stock: true
},
{
  id: 18,
  name: "WASHER, PLATE",
  oem: "90201-068G0-00",
  price: 2.99,
  stock: true
},
{
  id: 19,
  name: "BOLT",
  oem: "F2S-U1516-00-00",
  price: 7.99,
  stock: true
},
{
  id: 20,
  name: "BOLT",
  oem: "91380-04030-00",
  price: 0.99,
  stock: true
},
{
  id: 21,
  name: "SWITCH BOX ASSY",
  oem: "F2X-68310-01-00",
  price: 936.49,
  stock: true
},
{
  id: 22,
  name: "LANYARD, STOP SWITCH",
  oem: "EW2-68348-00-00",
  price: 37.49,
  stock: true
},
{
  id: 23,
  name: "BOLT, THROTTLE",
  oem: "6CS-6725F-00-00",
  price: 5.99,
  stock: true
},
{
  id: 24,
  name: "STOP BUTTON COMP",
  oem: "FK7-68312-02-00",
  price: 13.99,
  stock: true
},
{
  id: 25,
  name: "START BUTTON COMP.",
  oem: "FK7-68313-02-00",
  price: 11.99,
  stock: true
},
{
  id: 26,
  name: "THROTTLE LEVER COMP",
  oem: "6CS-14305-10-00",
  price: 700.99,
  stock: true
},
{
  id: 27,
  name: "SWITCH ASSY",
  oem: "6CS-81860-00-00",
  price: 252.99,
  stock: true
},
{
  id: 28,
  name: "BOLT, THROTTLE",
  oem: "6CS-6725F-00-00",
  price: 5.99,
  stock: true
},


{
  id: 29,
  name: "STEERING MASTER ASSY",
  oem: "F2X-61400-00-00",
  price: 583.99,
  stock: true
},
{
  id: 30,
  name: "SHAFT ASSY",
  oem: "F2X-67410-00-00",
  price: 194.99,
  stock: true
},
{
  id: 31,
  name: "PIPE, SEAL",
  oem: "F2X-61435-00-00",
  price: 11.99,
  stock: true
},
{
  id: 32,
  name: "HOUSING ASSY",
  oem: "F2X-6152M-00-00",
  price: 151.99,
  stock: true
},
{
  id: 33,
  name: "BUSH",
  oem: "F1K-6134M-00-00",
  price: 7.49,
  stock: true
},
{
  id: 34,
  name: "BAND",
  oem: "703-82591-00-00",
  price: 5.49,
  stock: true
},
{
  id: 35,
  name: "SPACER, BRKT.",
  oem: "F2X-6146H-00-00",
  price: 19.99,
  stock: true
},
{
  id: 36,
  name: "SCREW",
  oem: "F1B-613C1-00-00",
  price: 10.99,
  stock: true
},
{
  id: 37,
  name: "ARM ASSY.",
  oem: "F1K-6153R-00-00",
  price: 137.49,
  stock: true
},
{
  id: 38,
  name: "STUD, JOINT BALL",
  oem: "EU0-61461-02-00",
  price: 14.49,
  stock: true
},
{
  id: 39,
  name: "NUT, SELF-LOCKING",
  oem: "95720-06300-00",
  price: 1.99,
  stock: true
},
{
  id: 40,
  name: "BOLT",
  oem: "F1K-61355-00-00",
  price: 17.49,
  stock: true
},
{
  id: 41,
  name: "PLATE, RETAINING",
  oem: "F1K-6142B-00-00",
  price: 6.49,
  stock: true
},
{
  id: 42,
  name: "NUT, SELF-LOCKING",
  oem: "95720-08300-00",
  price: 4.49,
  stock: true
},
{
  id: 43,
  name: "BUZZER",
  oem: "F1S-68341-00-00",
  price: 114.49,
  stock: true
},
{
  id: 44,
  name: "SENSOR, MAGNET",
  oem: "F2X-6838B-00-00",
  price: 135.99,
  stock: true
},
{
  id: 45,
  name: "SCREW",
  oem: "F2X-613C1-00-00",
  price: 1.99,
  stock: true
},
{
  id: 46,
  name: "MAGNET",
  oem: "F2X-6838C-00-00",
  price: 26.49,
  stock: true
},
{
  id: 47,
  name: "SEAL, RUBBER",
  oem: "F1K-6143C-00-00",
  price: 42.99,
  stock: true
},
{
  id: 48,
  name: "BRACKET, STOPPER CABLE",
  oem: "F3Y-U1467-00-00",
  price: 36.99,
  stock: true
},
{
  id: 49,
  name: "RIVET, BLIND",
  oem: "90267-489U2-00",
  price: 5.99,
  stock: true
},
{
  id: 50,
  name: "BOLT, WITH WASHER",
  oem: "90119-08836-00",
  price: 22.99,
  stock: true
},
{
  id: 51,
  name: "STOPPER, CABLE",
  oem: "F1K-U1468-03-00",
  price: 11.99,
  stock: true
},
{
  id: 52,
  name: "BOLT, WITH WASHER",
  oem: "90119-069UH-00",
  price: 1.60,
  stock: true
},
{
  id: 53,
  name: "HOLDER, HANDLE UPPER",
  oem: "EU0-23814-31-00",
  price: 20.99,
  stock: true
},
{
  id: 54,
  name: "BOLT, WITH WASHER",
  oem: "90119-08827-00",
  price: 1.99,
  stock: true
}



],


Seat: [
  {
    id: 1,
    name: "DOUBLE SEAT ASSY",
    oem: "F2X-U371A-80-00",
    price: 583.99,
    stock: true
  },
  {
    id: 2,
    name: "COVER, SEAT 1",
    oem: "F2X-U371B-80-00",
    price: 419.99,
    stock: true
  },
  {
    id: 3,
    name: "PACKING",
    oem: "F1W-U2664-01-00",
    price: 45.99,
    stock: true
  },
  {
    id: 4,
    name: "SEAT LOCK ASSY",
    oem: "F2C-U3850-00-00",
    price: 34.99,
    stock: true
  },
  {
    id: 5,
    name: "BOLT, WITH WASHER",
    oem: "90119-069UP-00",
    price: 3.90,
    stock: true
  },
  {
    id: 6,
    name: "SINGLE SEAT ASSY",
    oem: "F2X-U372A-80-00",
    price: 448.99,
    stock: true
  },
  {
    id: 7,
    name: "COVER, SEAT",
    oem: "F2X-U372B-80-00",
    price: 332.99,
    stock: true
  },
  {
    id: 8,
    name: "PACKING 5",
    oem: "F2C-U266D-01-00",
    price: 22.99,
    stock: true
  },
  {
    id: 9,
    name: "SEAT LOCK ASSY",
    oem: "F1B-U3850-02-00",
    price: 12.99,
    stock: true
  },
  {
    id: 10,
    name: "BOLT, WITH WASHER",
    oem: "90119-069UP-00",
    price: 3.90,
    stock: true
  },
  {
    id: 11,
    name: "DECK BEAM ASSY",
    oem: "F2S-U890L-04-00",
    price: 62.99,
    stock: true
  },
  {
    id: 12,
    name: "PIN",
    oem: "GH1-U3774-00-00",
    price: 28.99,
    stock: true
  },
  {
    id: 13,
    name: "WASHER, PLATE",
    oem: "90201-109U6-00",
    price: 5.99,
    stock: true
  },
  {
    id: 14,
    name: "WASHER",
    oem: "9299R-10200-00",
    price: 5.99,
    stock: true
  },
  {
    id: 15,
    name: "NUT, NYLON",
    oem: "9572R-10300-00",
    price: 8.99,
    stock: true
  },
  {
    id: 16,
    name: "PACKING 1",
    oem: "F2S-U375E-00-00",
    price: 8.99,
    stock: true
  },
  {
    id: 17,
    name: "PACKING",
    oem: "F2S-U8244-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 18,
    name: "BOLT, WITH WASHER",
    oem: "90119-08828-00",
    price: 6.99,
    stock: true
  },
  {
    id: 19,
    name: "NUT, FLANGE",
    oem: "9572R-08300-00",
    price: 11.80,
    stock: true
  },
  {
    id: 20,
    name: "WASHER",
    oem: "9299R-08200-00",
    price: 2.45,
    stock: true
  },
  {
    id: 21,
    name: "STAY, SEAT 1",
    oem: "F2X-U378C-00-00",
    price: 31.99,
    stock: true
  },
  {
    id: 22,
    name: "WASHER, PLATE",
    oem: "90201-099U3-00",
    price: 6.99,
    stock: true
  },
  {
    id: 23,
    name: "NUT, FLANGE",
    oem: "9572R-08300-00",
    price: 11.80,
    stock: true
  },
  {
    id: 24,
    name: "GRIP, HAND",
    oem: "F2X-U271B-10-00",
    price: 200.99,
    stock: true
  },
  {
    id: 25,
    name: "PIN",
    oem: "F1K-U3774-00-00",
    price: 23.99,
    stock: true
  },
  {
    id: 26,
    name: "BOLT, WITH WASHER",
    oem: "90119-10804-00",
    price: 8.99,
    stock: true
  },
  {
    id: 27,
    name: "WASHER",
    oem: "9299R-10200-00",
    price: 5.99,
    stock: true
  },
  {
    id: 28,
    name: "BOLT, WITH WASHER",
    oem: "90119-08828-00",
    price: 6.99,
    stock: true
  },
  {
    id: 29,
    name: "WASHER",
    oem: "9299R-08200-00",
    price: 2.45,
    stock: true
  },
  {
    id: 30,
    name: "NUT, FLANGE",
    oem: "9572R-08300-00",
    price: 11.80,
    stock: true
  },
  {
    id: 31,
    name: "CASE ASSY 1",
    oem: "F2X-U591A-01-00",
    price: 59.99,
    stock: true
  },
  {
    id: 32,
    name: "CAP, CASE",
    oem: "F2C-U591C-00-00",
    price: 11.99,
    stock: true
  },
  {
    id: 33,
    name: "PACKING, CASE",
    oem: "F2C-U591D-01-00",
    price: 3.99,
    stock: true
  },
  {
    id: 34,
    name: "PACKING 6",
    oem: "F2C-U266E-00-00",
    price: 22.99,
    stock: true
  },
  {
    id: 35,
    name: "STERN EYE",
    oem: "F2N-U1628-02-00",
    price: 8.99,
    stock: true
  },
  {
    id: 36,
    name: "PLATE A",
    oem: "GP7-U4953-10-00",
    price: 8.99,
    stock: true
  },
  {
    id: 37,
    name: "NUT, FLANGE",
    oem: "9572R-08300-00",
    price: 11.80,
    stock: true
  }
],

  Exhaust: [

{
  id: 1,
  name: "GASKET, EXHAUST PIPE",
  oem: "6BH-14613-00-00",
  price: 52.99,
  stock: true
},
{
  id: 2,
  name: "MUFFLER 1",
  oem: "6BH-14711-11-00",
  price: 719.49,
  stock: true
},
{
  id: 3,
  name: "PIN, DOWEL",
  oem: "93608-16M16-00",
  price: 2.85,
  stock: true
},
{
  id: 4,
  name: "BOLT, WITH WASHER",
  oem: "90119-08034-00",
  price: 4.49,
  stock: true
},
{
  id: 5,
  name: "BOLT, WITH WASHER",
  oem: "90119-08097-00",
  price: 6.99,
  stock: true
},
{
  id: 6,
  name: "MUFFLER 2",
  oem: "6BH-14721-11-00",
  price: 904.49,
  stock: true
},
{
  id: 7,
  name: "GASKET, MUFFLER DAMPER 1",
  oem: "6S5-14739-00-00",
  price: 29.99,
  stock: true
},
{
  id: 8,
  name: "PIN, DOWEL",
  oem: "93606-12019-00",
  price: 4.60,
  stock: true
},
{
  id: 9,
  name: "BOLT, WITH WASHER",
  oem: "90119-08097-00",
  price: 6.99,
  stock: true
},
{
  id: 10,
  name: "BOLT, WITH WASHER",
  oem: "90119-08034-00",
  price: 4.49,
  stock: true
},
{
  id: 11,
  name: "STAY, MUFFLER 1",
  oem: "6S5-14771-00-00",
  price: 75.99,
  stock: true
},
{
  id: 12,
  name: "BOLT, WITH WASHER",
  oem: "90119-08096-00",
  price: 5.49,
  stock: true
},
{
  id: 13,
  name: "BOLT, WITH WASHER",
  oem: "90119-10029-00",
  price: 4.49,
  stock: true
},
{
  id: 14,
  name: "GASKET, MUFFLER DAMPER 2",
  oem: "6BH-14749-00-00",
  price: 23.99,
  stock: true
},
{
  id: 15,
  name: "PIPE, TAIL",
  oem: "6BH-14784-01-00",
  price: 184.99,
  stock: true
},
{
  id: 16,
  name: "BOLT, FLANGE (SMALL HEAD)",
  oem: "95024-08035-00",
  price: 9.49,
  stock: true
},
{
  id: 17,
  name: "PIPE, OUTLET",
  oem: "6S5-E4752-00-00",
  price: 33.99,
  stock: true
},
{
  id: 18,
  name: "HOSE CLAMP ASSY",
  oem: "90450-99808-00",
  price: 10.99,
  stock: true
},
{
  id: 19,
  name: "HOSE CLAMP ASSY",
  oem: "90450-99809-00",
  price: 10.99,
  stock: true
},
{
  id: 20,
  name: "PIPE 1",
  oem: "6CS-1475A-00-00",
  price: 208.99,
  stock: true
},





{
  id: 21,
  name: "WATER LOCK COMP.",
  oem: "F1W-U7550-02-00",
  price: 359.99,
  stock: true
},
{
  id: 22,
  name: "PAD, BATTERY",
  oem: "F1S-U8221-00-00",
  price: 7.99,
  stock: true
},
{
  id: 23,
  name: "BAND, FUEL TANK",
  oem: "EW2-67821-00-00",
  price: 38.49,
  stock: true
},
{
  id: 24,
  name: "HOOK (A)",
  oem: "GA7-65772-00-00",
  price: 9.99,
  stock: true
},
{
  id: 25,
  name: "RIVET, BLIND",
  oem: "90267-489U1-00",
  price: 5.49,
  stock: true
},
{
  id: 26,
  name: "HOSE, EXHAUST",
  oem: "F2S-U7555-01-00",
  price: 91.99,
  stock: true
},
{
  id: 27,
  name: "RESONATOR 1",
  oem: "F2S-U753C-00-00",
  price: 161.99,
  stock: true
},
{
  id: 28,
  name: "BAND, HOSE (70)",
  oem: "90601-170UG-00",
  price: 11.99,
  stock: true
},
{
  id: 29,
  name: "MAT 2",
  oem: "F1K-U759C-00-00",
  price: 5.99,
  stock: true
},
{
  id: 30,
  name: "HOSE CLAMP ASSY",
  oem: "90450-99801-00",
  price: 8.99,
  stock: true
},
{
  id: 31,
  name: "HOSE CLAMP ASSY",
  oem: "90450-99804-00",
  price: 8.99,
  stock: true
},
{
  id: 32,
  name: "TANK, WATER",
  oem: "F2N-U4261-00-00",
  price: 114.99,
  stock: true
},
{
  id: 33,
  name: "PAD, BATTERY",
  oem: "F1S-U8221-00-00",
  price: 7.99,
  stock: true
},
{
  id: 34,
  name: "HOSE, EXHAUST 3",
  oem: "F2N-U758D-00-00",
  price: 220.99,
  stock: true
},
{
  id: 35,
  name: "HOSE CLAMP ASSY",
  oem: "90450-99801-00",
  price: 8.99,
  stock: true
},
{
  id: 36,
  name: "VALVE, EXHAUST",
  oem: "F1B-U751G-00-00",
  price: 9.99,
  stock: true
},
{
  id: 37,
  name: "PLATE",
  oem: "F1S-U757B-01-00",
  price: 34.99,
  stock: true
},
{
  id: 38,
  name: "NUT, LOCK",
  oem: "F2N-U142L-00-00",
  price: 5.99,
  stock: true
},
{
  id: 39,
  name: "PILOT, WATER",
  oem: "F2C-U753B-01-00",
  price: 6.99,
  stock: true
},
{
  id: 40,
  name: "GASKET",
  oem: "F2C-U7564-00-00",
  price: 6.99,
  stock: true
},
{
  id: 41,
  name: "NUT",
  oem: "F2C-U2733-00-00",
  price: 5.99,
  stock: true
},
{
  id: 42,
  name: "BASE, CLAMP",
  oem: "F1W-U828M-00-00",
  price: 5.99,
  stock: true
},
{
  id: 43,
  name: "RIVET, BLIND",
  oem: "90267-489U6-00",
  price: 6.99,
  stock: true
},
{
  id: 44,
  name: "CLAMP",
  oem: "90464-32801-00",
  price: 5.99,
  stock: true
},
{
  id: 45,
  name: "CLIP",
  oem: "90467-150A5-00",
  price: 2.99,
  stock: true
},


{
  id: 46,
  name: "HOSE (L250)",
  oem: "90445-21806-00",
  price: 17.99,
  stock: true
},
{
  id: 47,
  name: "TUBE (L200)",
  oem: "90447-22801-00",
  price: 2.99,
  stock: true
},
{
  id: 48,
  name: "TUBE (L485)",
  oem: "90447-19801-00",
  price: 7.99,
  stock: true
},
{
  id: 49,
  name: "HOSE 2",
  oem: "6S5-1243E-01-00",
  price: 22.49,
  stock: true
},
{
  id: 50,
  name: "TUBE",
  oem: "F2T-U773D-00-00",
  price: 5.99,
  stock: true
},
{
  id: 51,
  name: "CLIP",
  oem: "90467-200A3-00",
  price: 7.99,
  stock: true
},
{
  id: 52,
  name: "JOINT, HOSE 3",
  oem: "6BH-12584-00-00",
  price: 5.99,
  stock: true
},
{
  id: 53,
  name: "HOSE (L400)",
  oem: "90445-18012-00",
  price: 24.99,
  stock: true
},
{
  id: 54,
  name: "TUBE (L260)",
  oem: "90447-19005-00",
  price: 3.99,
  stock: true
},
{
  id: 55,
  name: "CLIP",
  oem: "90467-160A0-00",
  price: 3.99,
  stock: true
},
{
  id: 56,
  name: "CLAMP",
  oem: "90464-35132-00",
  price: 10.49,
  stock: true
},
{
  id: 57,
  name: "HOSE 6",
  oem: "6S5-12589-01-00",
  price: 25.99,
  stock: true
},
{
  id: 58,
  name: "CLIP",
  oem: "90467-200A3-00",
  price: 7.99,
  stock: true
},
{
  id: 59,
  name: "HOSE 5",
  oem: "6BH-1244H-00-00",
  price: 20.99,
  stock: true
},
{
  id: 60,
  name: "CLIP",
  oem: "90467-150A1-00",
  price: 4.49,
  stock: true
},
{
  id: 61,
  name: "HOSE 5",
  oem: "6CN-12588-00-00",
  price: 33.99,
  stock: true
},
{
  id: 62,
  name: "TUBE (L860)",
  oem: "90447-19021-00",
  price: 6.99,
  stock: true
},
{
  id: 63,
  name: "CLIP",
  oem: "90467-160A0-00",
  price: 3.99,
  stock: true
},
{
  id: 64,
  name: "HOSE 2",
  oem: "6ET-12577-00-00",
  price: 7.99,
  stock: true
},
{
  id: 65,
  name: "CLIP",
  oem: "90467-160A0-00",
  price: 3.99,
  stock: true
},
{
  id: 66,
  name: "HOSE 4",
  oem: "6ET-12579-00-00",
  price: 8.99,
  stock: true
},
{
  id: 67,
  name: "CLIP",
  oem: "90467-160A0-00",
  price: 3.99,
  stock: true
},
{
  id: 68,
  name: "CLIP",
  oem: "90467-170A5-00",
  price: 4.99,
  stock: true
},
{
  id: 69,
  name: "HOSE 1",
  oem: "6ET-12576-00-00",
  price: 13.99,
  stock: true
},
{
  id: 70,
  name: "CLIP",
  oem: "90467-160A0-00",
  price: 3.99,
  stock: true
},
{
  id: 71,
  name: "CONDUCTION ASSY",
  oem: "67X-E2590-00-00",
  price: 7.99,
  stock: true
},
{
  id: 72,
  name: "JOINT, HOSE 1",
  oem: "60E-12581-00-00",
  price: 15.49,
  stock: true
},
{
  id: 73,
  name: "JOINT ASSY",
  oem: "63M-12580-00-00",
  price: 100.49,
  stock: true
},
{
  id: 74,
  name: "CLIP",
  oem: "90467-150A5-00",
  price: 2.99,
  stock: true
},
{
  id: 75,
  name: "STAY",
  oem: "60E-12443-00-00",
  price: 3.99,
  stock: true
},
{
  id: 76,
  name: "CAP 1",
  oem: "6EY-84385-00-00",
  price: 13.99,
  stock: true
},
{
  id: 77,
  name: "NUT",
  oem: "EU0-61652-00-00",
  price: 15.49,
  stock: true
},
{
  id: 78,
  name: "CLIP",
  oem: "90467-200A3-00",
  price: 7.99,
  stock: true
},
{
  id: 79,
  name: "CLIP",
  oem: "90467-200A3-00",
  price: 7.99,
  stock: true
},
{
  id: 80,
  name: "RIVET, BLIND",
  oem: "90267-489U1-00",
  price: 5.49,
  stock: true
},






],



 Fuel: [



{
  id: 1,
  name: "FUEL PUMP COMP",
  oem: "6S5-13907-02-00",
  price: 1176.99,
  stock: true
},
{
  id: 2,
  name: "FUEL SENDER ASSY",
  oem: "6S5-682E0-00-00",
  price: 326.99,
  stock: true
},
{
  id: 3,
  name: "DAMPER, STOPPER",
  oem: "60E-82556-00-00",
  price: 18.49,
  stock: true
},
{
  id: 4,
  name: "O-RING",
  oem: "70R-24489-00-00",
  price: 5.49,
  stock: true
},
{
  id: 5,
  name: "RIVET, BLIND",
  oem: "90267-489U2-00",
  price: 5.99,
  stock: true
},
{
  id: 6,
  name: "SOCKET, VENTILATION",
  oem: "GP7-62159-02-00",
  price: 18.49,
  stock: true
},
{
  id: 7,
  name: "RIVET, BLIND",
  oem: "90267-489U6-00",
  price: 6.99,
  stock: true
},
{
  id: 8,
  name: "PIPE, VENTILATION",
  oem: "F1G-62149-00-00",
  price: 11.49,
  stock: true
},
{
  id: 9,
  name: "BASE, CLAMP",
  oem: "F1W-U828M-00-00",
  price: 5.99,
  stock: true
},
{
  id: 10,
  name: "RIVET, BLIND",
  oem: "90267-489U6-00",
  price: 6.99,
  stock: true
},
{
  id: 11,
  name: "CLAMP",
  oem: "90464-32801-00",
  price: 5.99,
  stock: true
},
{
  id: 12,
  name: "BASE, CLAMP",
  oem: "F1W-U828M-00-00",
  price: 5.99,
  stock: true
},
{
  id: 13,
  name: "RIVET, BLIND",
  oem: "90267-489U6-00",
  price: 6.99,
  stock: true
},
{
  id: 14,
  name: "CLAMP",
  oem: "90464-32801-00",
  price: 5.99,
  stock: true
},
{
  id: 15,
  name: "TANK, FUEL",
  oem: "F2S-U7711-02-00",
  price: 313.99,
  stock: true
},
{
  id: 16,
  name: "RING",
  oem: "F1B-U7773-00-00",
  price: 30.99,
  stock: true
},
{
  id: 17,
  name: "PACKING, SEAL",
  oem: "F1B-67747-00-00",
  price: 22.49,
  stock: true
},
{
  id: 18,
  name: "NUT, NYLON",
  oem: "9572R-06300-00",
  price: 8.99,
  stock: true
},
{
  id: 19,
  name: "CAP, FUEL FILLER",
  oem: "F2X-U7831-00-00",
  price: 34.99,
  stock: true
},
{
  id: 20,
  name: "SOCKET",
  oem: "F2X-U7833-00-00",
  price: 50.99,
  stock: true
},
{
  id: 21,
  name: "PACKING",
  oem: "GP7-U7832-01-00",
  price: 11.99,
  stock: true
},
{
  id: 22,
  name: "CHAIN BALL",
  oem: "GP7-U7835-00-00",
  price: 7.99,
  stock: true
},
{
  id: 23,
  name: "TAPPING SCREW",
  oem: "90169-049U1-00",
  price: 5.99,
  stock: true
},
{
  id: 24,
  name: "RIVET, BLIND",
  oem: "90267-329UR-00",
  price: 5.99,
  stock: true
},
{
  id: 25,
  name: "PACKING FUEL FILLER",
  oem: "GP7-U7834-10-00",
  price: 7.99,
  stock: true
},
{
  id: 26,
  name: "NUT, FUEL FILLER",
  oem: "GP7-U783F-00-00",
  price: 7.99,
  stock: true
},
{
  id: 27,
  name: "HOSE",
  oem: "F2X-U7844-01-00",
  price: 39.99,
  stock: true
},
{
  id: 28,
  name: "BAND, HOSE (55)",
  oem: "90601-155U4-00",
  price: 11.99,
  stock: true
},
{
  id: 29,
  name: "BAND, HOSE (55)",
  oem: "90601-155U4-00",
  price: 11.99,
  stock: true
},
{
  id: 30,
  name: "CHECK VALVE",
  oem: "F3Y-U7767-00-00",
  price: 34.99,
  stock: true
},
{
  id: 31,
  name: "HOSE, AIR VENT 3",
  oem: "GP7-U785H-00-00",
  price: 13.99,
  stock: true
},
{
  id: 32,
  name: "CLAMP",
  oem: "90465-11829-00",
  price: 2.70,
  stock: true
},
{
  id: 33,
  name: "CLAMP",
  oem: "90465-11829-00",
  price: 2.70,
  stock: true
},
{
  id: 34,
  name: "HOSE, AIR VENT",
  oem: "F1K-U785G-00-00",
  price: 9.49,
  stock: true
},
{
  id: 35,
  name: "CLAMP",
  oem: "90465-11829-00",
  price: 2.70,
  stock: true
},
{
  id: 36,
  name: "HOSE, AIR VENT 3",
  oem: "F0D-U7856-10-00",
  price: 18.99,
  stock: true
},
{
  id: 37,
  name: "HOOK (A)",
  oem: "F1K-U5772-04-00",
  price: 11.99,
  stock: true
},
{
  id: 38,
  name: "RIVET, BLIND",
  oem: "90267-489U1-00",
  price: 5.49,
  stock: true
},
{
  id: 39,
  name: "BELT, TANK 1",
  oem: "F2S-67743-00-00",
  price: 53.99,
  stock: true
},
{
  id: 40,
  name: "MAT 1",
  oem: "F2S-U759B-00-00",
  price: 7.99,
  stock: true
},
{
  id: 41,
  name: "MAT 1",
  oem: "F2S-U759B-00-00",
  price: 7.99,
  stock: true
},
{
  id: 42,
  name: "MAT 2",
  oem: "F1W-U759C-01-00",
  price: 6.99,
  stock: true
},
{
  id: 43,
  name: "MAT 2",
  oem: "F1W-U759C-01-00",
  price: 6.99,
  stock: true
},
{
  id: 44,
  name: "MAT 2",
  oem: "F1K-U759C-00-00",
  price: 5.99,
  stock: true
},
{
  id: 45,
  name: "PAD, BATTERY",
  oem: "F1S-U8221-00-00",
  price: 7.99,
  stock: true
},
{
  id: 46,
  name: "TUBE",
  oem: "F4L-U773D-00-00",
  price: 36.99,
  stock: true
}



  ],

  Hull: {
  "Body": [
   {
  id: 1,
  name: "FUEL PUMP COMP.",
  oem: "6S5-13907-02-00",
  price: 1176.99,
  stock: true
},
{
  id: 2,
  name: "FUEL SENDER ASSY",
  oem: "6S5-682E0-00-00",
  price: 326.99,
  stock: true
},
{
  id: 3,
  name: "DAMPER, STOPPER",
  oem: "60E-82556-00-00",
  price: 18.49,
  stock: true
},
{
  id: 4,
  name: "TRANSMITTER COMP",
  oem: "6B6-86261-00-00",
  price: 357.99,
  stock: true
},
{
  id: 5,
  name: "RECEIVER COMPLETE",
  oem: "6B6-86265-00-00",
  price: 433.49,
  stock: true
},
{
  id: 6,
  name: "BATTERY ASSY (YB16CL-B) (YUASA)",
  oem: "EU0-82110-09-00",
  price: 218.99,
  stock: true
},
{
  id: 7,
  name: "PLATE, BASE 2",
  oem: "F2S-U8592-00-00",
  price: 9.99,
  stock: true
},
{
  id: 8,
  name: "PLATE, BASE 3",
  oem: "F2S-U8593-00-00",
  price: 9.99,
  stock: true
},
{
  id: 9,
  name: "RIVET, BLIND",
  oem: "90267-489U1-00",
  price: 5.49,
  stock: true
},
{
  id: 10,
  name: "CASE, BATTERY",
  oem: "F2S-U8211-00-00",
  price: 12.99,
  stock: true
},
{
  id: 11,
  name: "BOLT, WITH WASHER",
  oem: "90119-06832-00",
  price: 8.99,
  stock: true
},
{
  id: 12,
  name: "NUT, LOCK",
  oem: "F2N-U142L-00-00",
  price: 5.99,
  stock: true
},
{
  id: 13,
  name: "PAD, BATTERY",
  oem: "F1S-U8221-00-00",
  price: 7.99,
  stock: true
},
{
  id: 14,
  name: "PAD, BATTERY 2",
  oem: "EU0-U8221-30-00",
  price: 2.99,
  stock: true
},
{
  id: 15,
  name: "PAD, BATTERY",
  oem: "F1K-U8221-00-00",
  price: 6.99,
  stock: true
},
{
  id: 16,
  name: "BAND, BATTERY 1",
  oem: "EU0-U821D-00-00",
  price: 13.99,
  stock: true
},
{
  id: 17,
  name: "HOSE, AIR VENT",
  oem: "F0D-U785G-10-00",
  price: 8.49,
  stock: true
},
{
  id: 18,
  name: "CLIP",
  oem: "90467-089U1-00",
  price: 5.99,
  stock: true
},
{
  id: 19,
  name: "NIPPLE",
  oem: "GJ3-6215F-00-00",
  price: 9.99,
  stock: true
},
{
  id: 20,
  name: "CLAMP",
  oem: "90465-11829-00",
  price: 2.70,
  stock: true
},
{
  id: 21,
  name: "METER ASSY",
  oem: "F4E-6820A-01-00",
  price: 620.49,
  stock: true
},
{
  id: 22,
  name: "BOLT, WITH WASHER",
  oem: "90119-05803-00",
  price: 7.99,
  stock: true
},
{
  id: 23,
  name: "GROMMET",
  oem: "GU2-6822E-01-00",
  price: 24.99,
  stock: true
},
{
  id: 24,
  name: "GROMMET",
  oem: "F3J-U822E-00-00",
  price: 11.99,
  stock: true
},
{
  id: 25,
  name: "CLAMP",
  oem: "90464-32801-00",
  price: 5.99,
  stock: true
},
{
  id: 26,
  name: "PACKING, HOSE 2",
  oem: "GJ1-U7578-21-00",
  price: 1.99,
  stock: true
},
{
  id: 27,
  name: "PACKING, HOSE 2",
  oem: "GJ1-U7578-11-00",
  price: 2.99,
  stock: true
},
{
  id: 28,
  name: "SENSOR SPEED",
  oem: "F1S-U8K31-02-00",
  price: 197.99,
  stock: true
},
{
  id: 29,
  name: "NUT",
  oem: "F2C-U151S-00-00",
  price: 3.99,
  stock: true
},
{
  id: 30,
  name: "SCREW, ROUND HEAD",
  oem: "90150-05807-00",
  price: 1.99,
  stock: true
},
{
  id: 31,
  name: "BASE, CLAMP",
  oem: "F1W-U828M-00-00",
  price: 5.99,
  stock: true
},
{
  id: 32,
  name: "RIVET, BLIND",
  oem: "90267-489U6-00",
  price: 6.99,
  stock: true
},
{
  id: 33,
  name: "CLAMP",
  oem: "F3J-U8368-01-00",
  price: 10.99,
  stock: true
},
{
  id: 34,
  name: "RIVET, BLIND",
  oem: "90267-409U5-00",
  price: 0.00,
  stock: true
},
{
  id: 35,
  name: "BAND",
  oem: "90601-200U2-00",
  price: 8.99,
  stock: true
},
{
  id: 36,
  name: "BRACKET",
  oem: "F1W-U826C-00-00",
  price: 24.99,
  stock: true
},
{
  id: 37,
  name: "PLATE",
  oem: "F1W-U8376-00-00",
  price: 6.99,
  stock: true
},
{
  id: 38,
  name: "WIRE, MINUS LEAD",
  oem: "6S5-82116-00-00",
  price: 65.99,
  stock: true
}

  
  ],



"Front Cover / Hood": [
  {
    id: 1,
    name: "LID, ENGINE ROOM (DNMC - DARK GRAY METALLIC)",
    oem: "F2X-U517B-10-P0",
    price: 255.99,
    stock: true
  },
  {
    id: 2,
    name: "LID, ENGINE ROOM (PURW - PURE WHITE FOR DPBM11 - BLUE METALLIC)",
    oem: "F2X-U517B-10-P1",
    price: 325.99,
    stock: true
  },
  {
    id: 3,
    name: "INNER, ENGINE HATCH",
    oem: "F2X-U519G-10-00",
    price: 304.99,
    stock: true
  },
  {
    id: 4,
    name: "DAMPER 1",
    oem: "F2C-U515D-00-00",
    price: 6.99,
    stock: true
  },
  {
    id: 5,
    name: "CUSHION, RUBBER",
    oem: "F1W-U3768-01-00",
    price: 5.99,
    stock: true
  },
  {
    id: 6,
    name: "SCREW",
    oem: "F2S-U13C1-00-00",
    price: 6.99,
    stock: true
  },
  {
    id: 7,
    name: "PACKING 1",
    oem: "F2N-U2663-01-00",
    price: 60.99,
    stock: true
  },
  {
    id: 8,
    name: "LOCK, LID",
    oem: "F2X-U517C-01-00",
    price: 12.99,
    stock: true
  },
  {
    id: 9,
    name: "HINGE ASSY.",
    oem: "F2X-U515A-01-00",
    price: 369.99,
    stock: true
  },
  {
    id: 10,
    name: "PLATE, HINGE LID",
    oem: "F1K-U518E-04-00",
    price: 48.99,
    stock: true
  },
  {
    id: 11,
    name: "HINGE, LID",
    oem: "F1K-U517D-05-00",
    price: 332.99,
    stock: true
  },
  {
    id: 12,
    name: "ROLLER, DETENT",
    oem: "F2X-U135C-00-00",
    price: 12.99,
    stock: true
  },
  {
    id: 13,
    name: "PIN, HINGE",
    oem: "F1K-U517R-01-00",
    price: 7.99,
    stock: true
  },
  {
    id: 14,
    name: "SPACER 1",
    oem: "F1K-U471E-03-00",
    price: 18.99,
    stock: true
  },
  {
    id: 15,
    name: "SPRING, TORSION",
    oem: "F1K-U283B-02-00",
    price: 11.99,
    stock: true
  },
  {
    id: 16,
    name: "BOLT, FLANGE",
    oem: "90105-06826-00",
    price: 6.99,
    stock: true
  },
  {
    id: 17,
    name: "NUT, NYLON",
    oem: "9572R-06300-00",
    price: 8.99,
    stock: true
  },
  {
    id: 18,
    name: "WASHER",
    oem: "9299R-06200-00",
    price: 0.75,
    stock: true
  },
  {
    id: 19,
    name: "SCREW",
    oem: "F4G-U7823-10-00",
    price: 10.99,
    stock: true
  },
  {
    id: 20,
    name: "LOCKER,BOW",
    oem: "F2X-U475B-00-00",
    price: 199.99,
    stock: true
  },
  {
    id: 21,
    name: "PACKING 4",
    oem: "F2N-U266C-01-00",
    price: 12.99,
    stock: true
  },
  {
    id: 22,
    name: "PLUG, BLIND",
    oem: "90605-502U1-00",
    price: 6.99,
    stock: true
  },
  {
    id: 23,
    name: "RIVET",
    oem: "90269-08801-00",
    price: 5.99,
    stock: true
  },
  {
    id: 24,
    name: "PLATE, LOKER BOW",
    oem: "F2S-U475F-00-00",
    price: 17.99,
    stock: true
  },
  {
    id: 25,
    name: "RIVET",
    oem: "90269-08801-00",
    price: 5.99,
    stock: true
  },

  // MIRROR VARIANTS
  {
    id: 26,
    name: "MIRROR ASSY. 1 (DNMC - DARK GRAY METALLIC)",
    oem: "F2X-U590D-30-00",
    price: 160.99,
    stock: true
  },
  {
    id: 27,
    name: "MIRROR ASSY. 1 (DPBM11 - DARK PURPLISH BLUE METALLIC)",
    oem: "F2X-U590D-70-00",
    price: 163.99,
    stock: true
  },
  {
    id: 28,
    name: "CUSHION, RUBBER",
    oem: "F1W-U3768-01-00",
    price: 5.99,
    stock: true
  },
  {
    id: 29,
    name: "PACKING 3",
    oem: "F1K-U266B-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 30,
    name: "MIRROR ASSY. 2 (DPBM11 - DARK PURPLISH BLUE METALLIC)",
    oem: "F2X-U590E-70-00",
    price: 163.99,
    stock: true
  },
  {
    id: 31,
    name: "MIRROR ASSY. 2 (DNMC - DARK GRAY METALLIC)",
    oem: "F2X-U590E-30-00",
    price: 160.99,
    stock: true
  },
  {
    id: 32,
    name: "CUSHION, RUBBER",
    oem: "F1W-U3768-01-00",
    price: 5.99,
    stock: true
  },
  {
    id: 33,
    name: "PACKING 3",
    oem: "F1K-U266B-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 34,
    name: "SCREW",
    oem: "F2X-U13C1-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 35,
    name: "HOOK (A)",
    oem: "F1K-U5772-04-00",
    price: 11.99,
    stock: true
  },
  {
    id: 36,
    name: "RIVET,BLIND",
    oem: "90267-489U1-00",
    price: 5.49,
    stock: true
  },
  {
    id: 37,
    name: "MAT 2",
    oem: "F1K-U759C-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 38,
    name: "BOX, FIRE EXTINGUISHER",
    oem: "F2X-U5983-00-00",
    price: 7.99,
    stock: true
  },
  {
    id: 39,
    name: "RIVET, BLIND",
    oem: "90267-48802-00",
    price: 6.99,
    stock: true
  },
  {
    id: 40,
    name: "BAND 1",
    oem: "F2P-U828K-00-00",
    price: 12.99,
    stock: true
  }
],


"Ventilation": [
  {
    id: 1,
    name: "BASE, AIR INTAKE",
    oem: "F2X-U2127-00-00",
    price: 12.99,
    stock: true
  },
  {
    id: 2,
    name: "PACKING",
    oem: "F2X-U2157-00-00",
    price: 10.99,
    stock: true
  },
  {
    id: 3,
    name: "RIVET, BLIND",
    oem: "90267-48806-00",
    price: 6.99,
    stock: true
  },
  {
    id: 4,
    name: "RIVET, BLIND",
    oem: "90267-48806-00",
    price: 6.99,
    stock: true
  },
  {
    id: 5,
    name: "HOSE, VENTILATOR 2",
    oem: "F2N-U213G-01-00",
    price: 50.99,
    stock: true
  },
  {
    id: 6,
    name: "BASE, CLAMP",
    oem: "F1W-U828M-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 7,
    name: "RIVET, BLIND",
    oem: "90267-489U6-00",
    price: 6.99,
    stock: true
  },
  {
    id: 8,
    name: "CLAMP",
    oem: "90464-99804-00",
    price: 7.99,
    stock: true
  }
],


  "Side Covers": [
    {
      id: 1,
      name: "HOOK, LID LOCK",
      oem: "F2X-U517F-00-00",
      price: 10.99,
      stock: true
    },
    {
      id: 2,
      name: "NUT",
      oem: "F4G-U517E-00-00",
      price: 2.99,
      stock: true
    },
    {
      id: 3,
      name: "BOLT, WITH WASHER",
      oem: "90119-06880-00",
      price: 8.99,
      stock: true
    },
    {
      id: 4,
      name: "COVER, CENTER",
      oem: "F2X-U5554-00-00",
      price: 176.99,
      stock: true
    },
    {
      id: 5,
      name: "BOLT, WITH WASHER",
      oem: "90119-06882-00",
      price: 8.99,
      stock: true
    },
    {
      id: 6,
      name: "PLATE, FIX",
      oem: "F2X-U5175-00-00",
      price: 5.99,
      stock: true
    },
    {
      id: 7,
      name: "RIVET, BLIND",
      oem: "90267-489U1-00",
      price: 5.49,
      stock: true
    },
    {
      id: 8,
      name: "DAMPER 1",
      oem: "F1X-U828E-01-00",
      price: 6.99,
      stock: true
    },
    {
      id: 9,
      name: "GROMMET",
      oem: "90480-19800-00",
      price: 15.99,
      stock: true
    },
    {
      id: 10,
      name: "SEAL, COVER CENTER",
      oem: "F2X-U555B-00-00",
      price: 7.99,
      stock: true
    },
    {
      id: 11,
      name: "COVER METER",
      oem: "F2X-U8262-00-00",
      price: 18.99,
      stock: true
    },
    {
      id: 12,
      name: "SCREW",
      oem: "F2S-U13C1-00-00",
      price: 6.99,
      stock: true
    },

    // COVER SIDE 1 (BOTH COLORS)
    {
      id: 13,
      name: "COVER, SIDE 1 (DNMC - DARK GRAY METALLIC)",
      oem: "F2X-U377B-10-P0",
      price: 181.99,
      stock: true
    },
    {
      id: 14,
      name: "COVER, SIDE 1 (DPBM11 - DARK PURPLISH BLUE METALLIC)",
      oem: "F2X-U377B-10-P1",
      price: 181.99,
      stock: true
    },

    {
      id: 15,
      name: "BOLT, HEX. SOCKET BUTTON",
      oem: "90111-06803-00",
      price: 7.99,
      stock: true
    },
    {
      id: 16,
      name: "NUT, LOCK",
      oem: "F2N-U142L-00-00",
      price: 5.99,
      stock: true
    },

    // ORNAMENT LEFT
    {
      id: 17,
      name: "ORNAMENT, SIDE (LEFT HAND) (DPBM11)",
      oem: "F3P-U377F-40-00",
      price: 119.99,
      stock: true
    },
    {
      id: 18,
      name: "ORNAMENT, SIDE (LEFT HAND) (DNMC)",
      oem: "F3P-U377F-20-00",
      price: 125.99,
      stock: true
    },

    {
      id: 19,
      name: "SCREW",
      oem: "F2N-67823-10-00",
      price: 2.49,
      stock: true
    },

    // INNER SIDE 1
    {
      id: 20,
      name: "INNER, COVER SIDE 1 (DNMC)",
      oem: "F2X-U377H-00-00",
      price: 7.99,
      stock: true
    },
    {
      id: 21,
      name: "INNER, COVER SIDE 1 (DPBM11)",
      oem: "F2X-U377H-10-00",
      price: 7.99,
      stock: true
    },

    // COVER SIDE 2
    {
      id: 22,
      name: "COVER, SIDE 2 (DPBM11)",
      oem: "F2X-U377C-10-P1",
      price: 181.99,
      stock: true
    },
    {
      id: 23,
      name: "COVER, SIDE 2 (DNMC)",
      oem: "F2X-U377C-10-P0",
      price: 181.99,
      stock: true
    },

    // ORNAMENT RIGHT
    {
      id: 24,
      name: "ORNAMENT, SIDE (RIGHT HAND) (DNMC)",
      oem: "F3P-U377G-20-00",
      price: 125.99,
      stock: true
    },
    {
      id: 25,
      name: "ORNAMENT, SIDE (RIGHT HAND) (DPBM11)",
      oem: "F3P-U377G-40-00",
      price: 23.99,
      stock: true
    },

    // INNER SIDE 2
    {
      id: 26,
      name: "INNER, COVER SIDE 2 (DPBM11)",
      oem: "F2X-U377J-10-00",
      price: 7.99,
      stock: true
    },
    {
      id: 27,
      name: "INNER, COVER SIDE 2 (DNMC)",
      oem: "F2X-U377J-00-00",
      price: 7.99,
      stock: true
    },

    // GLOVE BOX
    {
      id: 28,
      name: "BOX GLOVE",
      oem: "F2X-U516P-00-00",
      price: 16.99,
      stock: true
    },
    {
      id: 29,
      name: "GLOVE BOX HATCH ASSY.",
      oem: "F2X-U1708-00-00",
      price: 34.99,
      stock: true
    },
    {
      id: 30,
      name: "PACKING CASE",
      oem: "F2X-U519D-00-00",
      price: 18.99,
      stock: true
    },
    {
      id: 31,
      name: "LOCK",
      oem: "F2X-U2875-00-00",
      price: 6.99,
      stock: true
    }
  ],



"Gunwale Mat": [
  {
    id: 1,
    name: "GUNWALE, BOW (BLACK)",
    oem: "F2X-U2511-10-00",
    price: 61.99,
    stock: true
  },
  {
    id: 2,
    name: "BOLT, SPECIAL",
    oem: "F1W-U491K-00-00",
    price: 6.99,
    stock: true
  },
  {
    id: 3,
    name: "BOLT, HEXAGON SOCKET HEAD",
    oem: "90110-06191-00",
    price: 3.20,
    stock: true
  },
  {
    id: 4,
    name: "BOLT, HEXAGON SOCKET HEAD",
    oem: "90110-06191-00",
    price: 3.20,
    stock: true
  },
  {
    id: 5,
    name: "NUT, LOCK",
    oem: "F2N-U142L-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 6,
    name: "NUT, LOCK",
    oem: "F2N-U142L-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 7,
    name: "GUNWALE, SIDE (BLACK)",
    oem: "F2X-U2512-10-00",
    price: 56.99,
    stock: true
  },

  // color variants
  {
    id: 8,
    name: "INNER, GUNWALE (ORANGE)",
    oem: "F2X-U2519-B0-00",
    price: 34.99,
    stock: true
  },
  {
    id: 9,
    name: "INNER, GUNWALE (WHITE)",
    oem: "F2X-U2519-60-00",
    price: 29.99,
    stock: true
  },

  {
    id: 10,
    name: "RIVET, BLIND",
    oem: "90267-489U8-00",
    price: 6.99,
    stock: true
  },
  {
    id: 11,
    name: "RIVET, BLIND",
    oem: "90267-489U8-00",
    price: 6.99,
    stock: true
  },
  {
    id: 12,
    name: "WASHER",
    oem: "9299R-05200-00",
    price: 6.99,
    stock: true
  },
  {
    id: 13,
    name: "WASHER",
    oem: "9299R-05200-00",
    price: 6.99,
    stock: true
  },

  {
    id: 14,
    name: "GUNWALE, STERN 1 (BLACK)",
    oem: "F2X-U251D-10-00",
    price: 23.99,
    stock: true
  },
  {
    id: 15,
    name: "BOLT, SPECIAL",
    oem: "F1W-U491K-00-00",
    price: 6.99,
    stock: true
  },
  {
    id: 16,
    name: "NUT, LOCK",
    oem: "F2N-U142L-00-00",
    price: 5.99,
    stock: true
  },
  {
    id: 17,
    name: "GUNWALE, STERN 2 (BLACK)",
    oem: "F2X-U251E-10-00",
    price: 23.99,
    stock: true
  },
  {
    id: 18,
    name: "BOLT, SPECIAL",
    oem: "F1W-U491K-00-00",
    price: 6.99,
    stock: true
  },
  {
    id: 19,
    name: "NUT, LOCK",
    oem: "F2N-U142L-00-00",
    price: 5.99,
    stock: true
  },

  {
    id: 20,
    name: "RIVET, BLIND",
    oem: "90267-48825-00",
    price: 6.99,
    stock: true
  },
  {
    id: 21,
    name: "RIVET, BLIND",
    oem: "90267-48825-00",
    price: 6.99,
    stock: true
  },

  // mats
  {
    id: 22,
    name: "MAT, UPPER",
    oem: "F2X-U3581-01-00",
    price: 97.99,
    stock: true
  },
  {
    id: 23,
    name: "MAT, STEP 1",
    oem: "F2X-U351H-00-00",
    price: 25.99,
    stock: true
  },
  {
    id: 24,
    name: "MAT, STEP 2",
    oem: "F2X-U351J-00-00",
    price: 25.99,
    stock: true
  },
  {
    id: 25,
    name: "MAT, STEP 3",
    oem: "F2X-U351K-00-00",
    price: 23.99,
    stock: true
  },
  {
    id: 26,
    name: "MAT, STEP 4",
    oem: "F2X-U351M-00-00",
    price: 34.99,
    stock: true
  },
  {
    id: 27,
    name: "MAT, STEP 5",
    oem: "F2X-U351N-00-00",
    price: 34.99,
    stock: true
  },

  // ornaments (variants preserved)
  {
    id: 28,
    name: "ORNAMENT, STERN (LEFT HAND) (WHITE)",
    oem: "F2X-U89A8-50-00",
    price: 39.99,
    stock: true
  },
  {
    id: 29,
    name: "ORNAMENT, STERN (LEFT HAND) (RED)",
    oem: "F2X-U89A8-41-00",
    price: 109.99,
    stock: true
  },
  {
    id: 30,
    name: "ORNAMENT, STERN (RIGHT HAND) (RED)",
    oem: "F2X-U89A9-41-00",
    price: 230.99,
    stock: true
  },
  {
    id: 31,
    name: "ORNAMENT, STERN (RIGHT HAND) (WHITE)",
    oem: "F2X-U89A9-50-00",
    price: 39.99,
    stock: true
  },
  {
    id: 32,
    name: "ORNAMENT, MIDDLE (LEFT HAND) (WHITE)",
    oem: "F2X-U89AA-50-00",
    price: 150.99,
    stock: true
  },
  {
    id: 33,
    name: "ORNAMENT, MIDDLE (LEFT HAND) (RED)",
    oem: "F2X-U89AA-41-00",
    price: 29.99,
    stock: true
  },
  {
    id: 34,
    name: "ORNAMENT, MIDDLE (RIGHT HAND) (WHITE)",
    oem: "F2X-U89AB-50-00",
    price: 150.99,
    stock: true
  },
  {
    id: 35,
    name: "ORNAMENT, MIDDLE (RIGHT HAND) (RED)",
    oem: "F2X-U89AB-41-00",
    price: 203.99,
    stock: true
  },
  {
    id: 36,
    name: "ORNAMENT, BOW (LEFT HAND) (WHITE)",
    oem: "F2X-U89AC-50-00",
    price: 78.99,
    stock: true
  },
  {
    id: 37,
    name: "ORNAMENT, BOW (LEFT HAND) (RED)",
    oem: "F2X-U89AC-41-00",
    price: 298.99,
    stock: true
  },
  {
    id: 38,
    name: "ORNAMENT, BOW (RIGHT HAND) (WHITE)",
    oem: "F2X-U89AD-50-00",
    price: 79.99,
    stock: true
  },
  {
    id: 39,
    name: "ORNAMENT, BOW (RIGHT HAND) (RED)",
    oem: "F2X-U89AD-41-00",
    price: 196.99,
    stock: true
  }
],




"Intake Grate / Plate": [
  {
    id: 1,
    name: "SPACER",
    oem: "F2X-U72C0-00-00",
    price: 22.99,
    stock: true
  },
  {
    id: 2,
    name: "PLATE 2",
    oem: "F2W-U273B-00-00",
    price: 0.00,
    stock: true
  },
  {
    id: 3,
    name: "BOLT, WITH WASHER",
    oem: "90119-08823-00",
    price: 8.99,
    stock: true
  },
  {
    id: 4,
    name: "BRACKET 2",
    oem: "F2X-U8572-00-00",
    price: 19.99,
    stock: true
  },
  {
    id: 5,
    name: "BRACKET 2",
    oem: "F2X-U8572-00-00",
    price: 19.99,
    stock: true
  },
  {
    id: 6,
    name: "BRACKET 3",
    oem: "F2S-U8577-00-00",
    price: 22.99,
    stock: true
  },
  {
    id: 7,
    name: "SCREEN, INTAKE",
    oem: "6EX-R1333-00-00",
    price: 98.99,
    stock: true
  },
  {
    id: 8,
    name: "BOLT, WITH WASHER",
    oem: "90119-08823-00",
    price: 8.99,
    stock: true
  },
  {
    id: 9,
    name: "BOLT, WITH WASHER",
    oem: "90119-08823-00",
    price: 8.99,
    stock: true
  },
  {
    id: 10,
    name: "BRACKET 1",
    oem: "F2X-U8571-00-00",
    price: 18.99,
    stock: true
  },
  {
    id: 11,
    name: "BRACKET 1",
    oem: "F2X-U8571-00-00",
    price: 18.99,
    stock: true
  },
  {
    id: 12,
    name: "BRACKET",
    oem: "F2C-U7557-01-00",
    price: 40.99,
    stock: true
  },
  {
    id: 13,
    name: "BOLT",
    oem: "90109-08041-00",
    price: 4.49,
    stock: true
  },
  {
    id: 14,
    name: "WASHER, PLAIN",
    oem: "92990-12200-00",
    price: 9.49,
    stock: true
  },
  {
    id: 15,
    name: "GASKET",
    oem: "90430-12002-00",
    price: 1.99,
    stock: true
  },
  {
    id: 16,
    name: "BOLT, WITH WASHER",
    oem: "90119-089U7-00",
    price: 8.99,
    stock: true
  }

],


"Fittings / Sponsons": [
  { id: 1, name: "SPOUT", oem: "F1W-U269B-00-00", price: 5.99, stock: true },
  { id: 2, name: "NUT", oem: "EU0-61652-00-00", price: 15.49, stock: true },
  { id: 3, name: "BAND, HOSE (18)", oem: "90601-118UF-00", price: 6.99, stock: true },
  { id: 4, name: "STRAINER, BILGE", oem: "F1B-U761D-02-00", price: 11.99, stock: true },
  { id: 5, name: "RIVET, BLIND", oem: "90267-489U8-00", price: 6.99, stock: true },
  { id: 6, name: "CLAMP", oem: "90465-11829-00", price: 2.70, stock: true },
  { id: 7, name: "HOSE (L860)", oem: "90445-20804-00", price: 17.99, stock: true },
  { id: 8, name: "TUBE 2", oem: "6EX-U773E-00-00", price: 9.99, stock: true },
  { id: 9, name: "HOSE (L500)", oem: "90445-20800-00", price: 17.99, stock: true },
  { id: 10, name: "TUBE", oem: "6EX-U773D-00-00", price: 7.99, stock: true },
  { id: 11, name: "JOINT, HOSE", oem: "68N-5112T-00-00", price: 49.49, stock: true },
  { id: 12, name: "CLIP", oem: "90467-200A3-00", price: 7.99, stock: true },
  { id: 13, name: "CLIP", oem: "90467-240A3-00", price: 2.99, stock: true },
  { id: 14, name: "CLIP", oem: "90467-180A5-00", price: 3.49, stock: true },
  { id: 15, name: "STERN EYE", oem: "F2N-U1628-02-00", price: 8.99, stock: true },
  { id: 16, name: "NUT, FLANGE", oem: "9572R-08300-00", price: 11.80, stock: true },
  { id: 17, name: "NUT, FLANGE", oem: "9572R-08300-00", price: 11.80, stock: true },
  { id: 18, name: "PLATE (A)", oem: "GP7-U4953-10-00", price: 8.99, stock: true },
  { id: 19, name: "PLATE (A)", oem: "GP7-U4953-10-00", price: 8.99, stock: true },
  { id: 20, name: "PLATE (A)", oem: "GP7-U4953-10-00", price: 8.99, stock: true },
  { id: 21, name: "PACKING", oem: "F1B-U1653-02-00", price: 4.99, stock: true },
  { id: 22, name: "BOW EYE 1", oem: "F1K-61624-00-00", price: 57.49, stock: true },
  { id: 23, name: "NUT.HEX.(COARS)", oem: "99780-12600-00", price: 3.49, stock: true },
  { id: 24, name: "WASHER, PLAIN", oem: "92990-12200-00", price: 9.49, stock: true },
  { id: 25, name: "WASHER", oem: "F0X-61637-00-00", price: 1.49, stock: true },
  { id: 26, name: "NUT (BOLT/NUT)", oem: "F0X-61652-00-00", price: 11.99, stock: true },
  { id: 27, name: "BOLT, HEXAGON SOCKET HEAD", oem: "90110-06040-00", price: 3.49, stock: true },
  { id: 28, name: "STABILIZER (LEFT HAND) (BLACK)", oem: "F1S-U883N-01-00", price: 45.99, stock: true },
  { id: 29, name: "STABILIZER (RIGHT HAND) (BLACK)", oem: "F1S-U883P-01-00", price: 45.99, stock: true },
  { id: 30, name: "BRACKET, STABILIZER", oem: "F1X-U883T-01-00", price: 54.99, stock: true },
  { id: 31, name: "BOLT, FLANGE", oem: "90105-08860-00", price: 8.99, stock: true },
  { id: 32, name: "BOLT, FLANGE", oem: "90105-08860-00", price: 8.99, stock: true },
  { id: 33, name: "SPACER", oem: "F2N-U8169-00-00", price: 5.99, stock: true },
  { id: 34, name: "SPACER", oem: "F2N-U8169-00-00", price: 5.99, stock: true },
  { id: 35, name: "DRAIN PLUG ASSY.", oem: "F1S-U2280-02-00", price: 16.99, stock: true },
  { id: 36, name: "PACKING, DRAIN", oem: "F1S-U2285-00-00", price: 4.99, stock: true },
  { id: 37, name: "SCREW, PAN HEAD", oem: "9788R-05025-00", price: 6.99, stock: true },
  { id: 38, name: "WASHER", oem: "9299R-05200-00", price: 6.99, stock: true },
  { id: 39, name: "WASHER", oem: "9299R-05200-00", price: 6.99, stock: true },
  { id: 40, name: "NUT, FLANGE", oem: "9572R-05300-00", price: 5.99, stock: true },
  { id: 41, name: "NUT, FLANGE", oem: "9572R-05300-00", price: 5.99, stock: true },
  { id: 42, name: "BRACKET", oem: "F1K-U826C-03-00", price: 17.99, stock: true },
  { id: 43, name: "RIVET, BLIND", oem: "90267-489U1-00", price: 5.49, stock: true },
  { id: 44, name: "BRACKET 2", oem: "F1W-U8572-01-00", price: 58.99, stock: true },
  { id: 45, name: "NUT, FLANGE", oem: "9572R-08300-00", price: 11.80, stock: true },
  { id: 46, name: "WASHER", oem: "9299R-08200-00", price: 2.45, stock: true },
  { id: 47, name: "CLAMP", oem: "90464-32801-00", price: 5.99, stock: true },
  { id: 48, name: "LADDER, STEP ASSY", oem: "F2X-U278A-00-00", price: 230.99, stock: true },
  { id: 49, name: "SLEEVE 1", oem: "F1W-U771H-00-00", price: 34.99, stock: true },
  { id: 50, name: "INNER, COVER SIDE 1", oem: "F2C-U377H-00-00", price: 7.99, stock: true },
  { id: 51, name: "PIN", oem: "F2C-U1314-00-00", price: 7.99, stock: true },
  { id: 52, name: "BRACKET, LADDER (LEFT HAND)", oem: "F2S-U278F-00-00", price: 26.99, stock: true },
  { id: 53, name: "PACKING, BRKT. 1", oem: "F2S-U278H-00-00", price: 8.99, stock: true },
  { id: 54, name: "BOLT, WITH WASHER", oem: "90119-08861-00", price: 1.99, stock: true },
  { id: 55, name: "BOLT, WITH WASHER", oem: "90119-08861-00", price: 1.99, stock: true }
]


}

};